// =====================================================
// ----------shopify xtendify themes js start-------
// =====================================================

/**
 * Run a callback when an element matching the selector becomes visible (IntersectionObserver).
 * Used for deferred init of history tab and other non-slider inits.
 */
function initWhenVisible(selector, initFn, options) {
  var el = document.querySelector(selector);
  if (!el || typeof initFn !== "function") return;
  if (!("IntersectionObserver" in window)) {
    initFn();
    return;
  }
  var opts = options || {};
  var initialized = false;
  var observer = new IntersectionObserver(
    function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !initialized) {
          initialized = true;
          initFn();
          obs.disconnect();
        }
      });
    },
    Object.assign({ root: null, threshold: 0.15 }, opts),
  );
  observer.observe(el);
}

// Lazy-load videos with data-video-lazy: load when visible to reduce TBT
function initLazyVideos() {
  var videos = document.querySelectorAll("video[data-video-lazy]");
  if (videos.length === 0) return;
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var video = entry.target;
        var src = video.getAttribute("data-src");
        if (src) {
          video.src = src;
          var source = video.querySelector("source[data-src]");
          if (source) {
            source.src = source.getAttribute("data-src");
          }
          video.load();
          video.removeAttribute("data-video-lazy");
        }
        observer.unobserve(video);
      });
    },
    { rootMargin: "50px", threshold: 0.01 },
  );
  videos.forEach(function (v) {
    observer.observe(v);
  });
}

document.addEventListener("DOMContentLoaded", async function () {
  initLazyVideos();
  // History tab init is handled by its own IIFE DOMContentLoaded listener (see initializeMuskHistoryTab).
});

// Cached once — these elements are static in the DOM
var _headerEl = document.querySelector(".musk-main-header");
var _mobileNavBottomEl = document.querySelector(".fusion-mobile-bottom-nav");

// Add and remove class header on scroll
function handleHeaderState() {
  var windowWidth = window.innerWidth;
  var scrollTop = window.scrollY || window.pageYOffset;

  /* ---------- Desktop ---------- */
  if (windowWidth > 1024) {
    _mobileNavBottomEl?.classList.remove("is-fixed");
    _headerEl?.classList.remove("is-top");

    if (scrollTop > 60) {
      _headerEl?.classList.add("is-sticky");
    } else {
      _headerEl?.classList.remove("is-sticky");
    }
  } else {
    /* ---------- Mobile (BROVI) ----------
       Keep the main header visible and never activate the removed bottom bar. */
    _mobileNavBottomEl?.classList.remove("is-fixed");
    _headerEl?.classList.remove("is-sticky", "is-top");
  }
}

/* Run on scroll (throttled to avoid long-task chains) */
var scrollRaf = null;
window.addEventListener("scroll", function () {
  if (scrollRaf != null) return;
  scrollRaf = requestAnimationFrame(function () {
    handleHeaderState();
    scrollRaf = null;
  });
});

/* Run on resize (throttled to avoid TBT during resize) */
var resizeRaf = null;
window.addEventListener("resize", function () {
  if (resizeRaf != null) return;
  resizeRaf = requestAnimationFrame(function () {
    handleHeaderState();
    resizeRaf = null;
  });
});

/* Run once on load */
handleHeaderState();

// -----------menu-drawer------------------
function menuBtnFunction(menuBtn) {
  menuBtn.classList.toggle("active");
  var isExpanded = menuBtn.classList.contains("active");
  menuBtn.setAttribute("aria-expanded", isExpanded);
}

// Handle `.mobile-menu-toggle` click
document.querySelectorAll(".mobile-menu-toggle").forEach(function (btn) {
  btn.addEventListener("click", function (e) {
    e.preventDefault();
    document
      .querySelector(".fusion-mobile-menu-drawer")
      ?.classList.toggle("active");
    document
      .querySelector(".fusion-overlay-custom")
      ?.classList.toggle("overlay-active");
    document.body.classList.toggle("overflow-hidden");
  });
});

// Handle `.sm-menu-top-toggle` click
document.querySelectorAll(".sm-menu-top-toggle").forEach(function (btn) {
  btn.addEventListener("click", function (e) {
    e.preventDefault();
    const drawer = document.querySelector(".fusion-mobile-menu-drawer");
    if (drawer) {
      drawer.classList.toggle("active");
      drawer.classList.toggle("bottom-touch");
    }
    document
      .querySelector(".fusion-overlay-custom")
      ?.classList.toggle("overlay-active");
    document.body.classList.toggle("overflow-hidden");
  });
});

// Handle outside click to close the menu
document.addEventListener("click", function (e) {
  // Check if search popup is active - don't interfere with it
  const searchPopup =
    document.querySelector(".fusion-search-popup") ||
    document.querySelector(".fusion-search-popup");
  const isSearchPopupActive =
    searchPopup &&
    (searchPopup.classList.contains("active") ||
      searchPopup.classList.contains("show"));

  // Don't close mobile menu if search popup is active
  if (isSearchPopupActive) return;

  const drawer = document.querySelector(".fusion-mobile-menu-drawer");
  const overlay = document.querySelector(".fusion-overlay-custom");
  const isClickInside = e.target.closest(
    ".fusion-mobile-menu-drawer, .mobile-menu-toggle, .sm-menu-top-toggle",
  );

  if (!isClickInside && drawer?.classList.contains("active")) {
    drawer.classList.remove("active", "bottom-touch");
    overlay?.classList.remove("overlay-active");

    document
      .querySelectorAll(".mobile-menu-toggle, .sm-menu-top-toggle")
      .forEach(function (btn) {
        btn.classList.remove("active");
      });
    document.body.classList.remove("overflow-hidden");
  }
});

function initializeSearchBarHandlers() {
  var isMobile = window.innerWidth < 1024;

  // Abort previous listeners cleanly — no DOM cloning needed
  if (initializeSearchBarHandlers._abort) {
    initializeSearchBarHandlers._abort.abort();
  }
  initializeSearchBarHandlers._abort = new AbortController();
  var signal = initializeSearchBarHandlers._abort.signal;

  if (isMobile) {
    document
      .querySelectorAll(".search-bar-main .header-resource-link")
      .forEach(function (el) {
        el.addEventListener(
          "click",
          function (e) {
            e.preventDefault();
            document
              .querySelector(".fusion-overlay-custom")
              ?.classList.toggle("overlay-active");
            document.body.classList.toggle("overflow-hidden");
          },
          { signal: signal },
        );
      });

    document
      .querySelectorAll(".fusion-mobile-nav .search-toggle")
      .forEach(function (el) {
        el.addEventListener(
          "click",
          function (e) {
            e.preventDefault();
            document
              .querySelector(".fusion-search-popup")
              ?.classList.add("active");
            _headerEl?.classList.add("remove_transform");
            document
              .querySelector(".fusion-overlay-custom")
              ?.classList.add("overlay-active");
            document.body.classList.add("overflow-hidden");
          },
          { signal: signal },
        );
      });

    document.querySelectorAll(".fusion-overlay-custom").forEach(function (el) {
      el.addEventListener(
        "click",
        function (e) {
          var searchPopup =
            document.querySelector(".fusion-search-popup") ||
            document.querySelector(".fusion-search-popup");
          var isSearchPopupActive =
            searchPopup &&
            (searchPopup.classList.contains("active") ||
              searchPopup.classList.contains("show"));
          var isClickInsidePopup =
            searchPopup && searchPopup.contains(e.target);

          if (isSearchPopupActive && !isClickInsidePopup) {
            e.preventDefault();
            e.stopPropagation();
            document
              .querySelector(".fusion-search-popup")
              ?.classList.remove("show");
            document
              .querySelector(".fusion-search-popup")
              ?.classList.remove("active");
            document
              .querySelector(".sm-search-drawer")
              ?.classList.remove("active", "bottom-touch");
            document
              .querySelector(".fusion-overlay-custom")
              ?.classList.remove("overlay-active");
            document.body.classList.remove("overflow-hidden");
          } else if (!isSearchPopupActive) {
            e.preventDefault();
            document
              .querySelector(".fusion-search-popup")
              ?.classList.remove("show");
            document
              .querySelector(".sm-search-drawer")
              ?.classList.remove("active", "bottom-touch");
            document
              .querySelector(".fusion-overlay-custom")
              ?.classList.remove("overlay-active");
            document.body.classList.remove("overflow-hidden");
          }
        },
        { signal: signal },
      );
    });
  }
  // Desktop: aborting the previous signal already removed all mobile listeners — nothing else to do
}

// Delay non-critical inits to reduce TBT / NO_TTI_CPU_IDLE_PERIOD (run 2s after load)
function initNonCriticalAfterLoad() {
  setTimeout(function () {
    initializeSearchBarHandlers();
  }, 2000);
}
if (document.readyState === "complete") {
  initNonCriticalAfterLoad();
} else {
  window.addEventListener("load", initNonCriticalAfterLoad);
}
// Run on window resize (handlers still needed for resize after delay)
window.addEventListener("resize", initializeSearchBarHandlers);

// Mobile submenu when clicking on icon
function initializeMuskSUBMENUCLOSE() {
  // Open submenu when clicking on icon inside <a>
  document
    .querySelectorAll(".fusion-mobile-menu-drawer nav li a i")
    .forEach((icon) => {
      icon.addEventListener("click", function (e) {
        e.preventDefault();
        const parentA = this.closest("a");
        if (!parentA) return;
        const submenu = parentA.nextElementSibling;
        if (submenu && submenu.classList.contains("fusion-submenu")) {
          submenu.classList.add("active");
        }
      });
    });

  // Close submenu when clicking icon with class sub-menu-close
  document
    .querySelectorAll(".fusion-mobile-menu-drawer nav li i.sub-menu-close")
    .forEach((icon) => {
      icon.addEventListener("click", function (e) {
        e.preventDefault();
        const innerTitle = this.closest(".inner-title");
        if (!innerTitle) return;
        const submenu = innerTitle.closest(".fusion-submenu");
        if (submenu) {
          submenu.classList.remove("active");
        }
      });
    });
}
initializeMuskSUBMENUCLOSE();

// Remove header class is-sticky on resize (uses cached _headerEl)
window.addEventListener("resize", function () {
  if (window.innerWidth >= 1024) {
    _headerEl?.classList.remove("is-sticky");
  }
});

document.addEventListener("DOMContentLoaded", function () {
  // Open cart drawer
  document
    .querySelectorAll(".cart-btn, .fusion-mobile-bottom-nav .cart-toggle")
    .forEach((btn) => {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        document.querySelector(".cart-sidebar")?.classList.add("active");
        document
          .querySelector(".fusion-overlay-custom")
          ?.classList.add("overlay-active");
        document.body.classList.add("overflow-hidden", "z-index");
      });
    });

  // Close cart drawer
  document
    .querySelectorAll(".cart-sidebar .cls-btn, .fusion-overlay-custom")
    .forEach((el) => {
      el.addEventListener("click", function (e) {
        // Check if search popup is active - don't interfere with it
        const searchPopup =
          document.querySelector(".fusion-search-popup") ||
          document.querySelector(".fusion-search-popup");
        const isSearchPopupActive =
          searchPopup &&
          (searchPopup.classList.contains("active") ||
            searchPopup.classList.contains("show"));
        const isClickInsideSearchPopup =
          searchPopup && searchPopup.contains(e.target);

        // Don't close cart sidebar if search popup is active and click is inside search popup
        if (isSearchPopupActive && isClickInsideSearchPopup) {
          e.stopPropagation();
          return;
        }

        // Only close cart sidebar if search popup is not active or click is outside search popup
        if (!isSearchPopupActive || !isClickInsideSearchPopup) {
          e.preventDefault();
          document.querySelector(".cart-sidebar")?.classList.remove("active");
          document
            .querySelector(".fusion-overlay-custom")
            ?.classList.remove("overlay-active");
          document.body.classList.remove("overflow-hidden", "z-index");
          var annfouncementBarremovec = document.querySelector(
            ".announcement-bar-main.box",
          );
          if (annfouncementBarremovec) {
            annfouncementBarremovec.classList.remove("search_clicked");
          }
        }
      });
    });

  // Prevent clicks inside header or cart-sidebar from bubbling out
  document.querySelectorAll("header, .cart-sidebar").forEach((el) => {
    el.addEventListener("click", function (e) {
      e.stopPropagation();
    });
  });

  // ----------footer collapse sm--------------
  const footerWrappers = document.querySelectorAll(".musk-main-footer");
  if (footerWrappers.length === 0) return;
  footerWrappers.forEach((wrapper) => {
    const accordions = wrapper.querySelectorAll(".ftraccordion");
    const panels = wrapper.querySelectorAll(".ftrpanel");

    /* --------------------  CLICK HANDLER  -------------------- */
    function accordionClick(e) {
      // Only act when viewport is < 768 px
      if (window.innerWidth >= 768) return;

      const acc = e.currentTarget; // clicked .ftraccordion
      const icon = acc.querySelector("i");
      const panel = acc.nextElementSibling; // associated .ftrpanel

      // Close every panel except the one we just clicked
      panels.forEach((p) => {
        if (p !== panel) p.style.display = "none";
      });

      // Remove "active" + reset icons on all other accordions
      accordions.forEach((a) => {
        if (a !== acc) {
          a.classList.remove("active");
          const ic = a.querySelector("i");
          if (ic) {
            ic.classList.remove("fa-minus");
            ic.classList.add("fa-plus");
          }
        }
      });

      // Toggle this accordion
      const isOpen = acc.classList.toggle("active");
      panel.style.display = isOpen ? "flex" : "none";
      if (icon) {
        icon.classList.toggle("fa-plus", !isOpen);
        icon.classList.toggle("fa-minus", isOpen);
      }
    }

    /* --------------------  APPLY RULES  -------------------- */
    function applyAccordion() {
      const isMobile = window.innerWidth < 768;

      if (isMobile) {
        // Collapse all panels initially
        panels.forEach((p) => (p.style.display = "none"));

        // Attach click listeners (avoid duplicates with {once:false})
        accordions.forEach((acc) => {
          acc.removeEventListener("click", accordionClick);
          acc.addEventListener("click", accordionClick);
        });
      } else {
        // Desktop view: show everything, reset classes/icons, remove listeners
        panels.forEach((p) => (p.style.display = "flex"));
        accordions.forEach((acc) => {
          acc.classList.remove("active");
          const ic = acc.querySelector("i");
          if (ic) {
            ic.classList.remove("fa-minus");
            ic.classList.add("fa-plus");
          }
          acc.removeEventListener("click", accordionClick);
        });
      }
    }

    // Initial run + resize listener
    applyAccordion();
    window.addEventListener("resize", applyAccordion);
  });
});

// ----------countdown js-------------------
document.addEventListener("DOMContentLoaded", function () {
  const countdownElements = document.querySelectorAll(".fusion-countdown");

  if (!countdownElements.length) return;

  countdownElements.forEach(function (el) {
    const endDateAttr = el.getAttribute("end_date");
    const endMessage = el.getAttribute("end_massage") || "";
    const countdownDate = new Date(endDateAttr + " 00:00:00").getTime();

    function updateCountdown() {
      const now = new Date().getTime();
      const distance = countdownDate - now;

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
      );
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      const daysEl = el.querySelector("#days");
      const hoursEl = el.querySelector("#hours");
      const minutesEl = el.querySelector("#minutes");
      const secondsEl = el.querySelector("#seconds");

      if (daysEl) daysEl.textContent = days;
      if (hoursEl) hoursEl.textContent = hours;
      if (minutesEl) minutesEl.textContent = minutes;
      if (secondsEl) secondsEl.textContent = seconds;

      if (distance < 0) {
        clearInterval(interval);
        el.textContent = endMessage;
      }
    }

    const interval = setInterval(updateCountdown, 1000);
    updateCountdown(); // Initial run
  });
});

// Befor After
function initializeMuskBEFOREAFTER() {
  window.addEventListener("load", () => {
    const slider = document.getElementById("slider_before_after");
    const frontImage = document.querySelector(".front-img");
    const container = document.querySelector(".before-after");

    if (!slider || !frontImage || !container) return;

    const updateSlider = () => {
      const value = slider.value;
      frontImage.style.clipPath = `polygon(0 0, ${value}% 0, ${value}% 100%, 0% 100%)`;
      container.style.setProperty("--position", `${value}%`);
    };

    // Set initial and live updates
    updateSlider();
    slider.addEventListener("input", updateSlider);
  });
}

initializeMuskBEFOREAFTER();

// -------------fusion-image-reveal- section js------------------
function initializeMuskIMAGEREVEAL(root = document) {
  const sections = root.querySelectorAll(".image-reveal-menu");

  sections.forEach((menuEl) => {
    // Prevent double init (Shopify editor reload fix)
    if (menuEl.dataset.imageRevealInit === "true") return;
    menuEl.dataset.imageRevealInit = "true";

    const map = (x, a, b, c, d) => ((x - a) * (d - c)) / (b - a) + c;
    const lerp = (a, b, n) => (1 - n) * a + n * b;
    const clamp = (num, min, max) =>
      num <= min ? min : num >= max ? max : num;

    const getMousePos = (ev) => ({
      x: ev.clientX,
      y: ev.clientY,
    });

    const DOM = { el: menuEl };
    DOM.menuItems = DOM.el.querySelectorAll(".menu__item");

    /* ---------------- Images ---------------- */
    let images = [...DOM.menuItems].map((item, index) => [
      index,
      item.getAttribute("data-img"),
    ]);

    /* ---------------- Mouse ---------------- */
    let mousepos = { x: 0, y: 0 };
    let mousePosCache = { ...mousepos };

    let direction = { x: 0, y: 0 };

    window.addEventListener("mousemove", (ev) => {
      mousepos = getMousePos(ev);
    });

    /* ---------------- Anim Props ---------------- */
    const animatableProperties = {
      tx: { previous: 0, current: 0, amt: 0.08 },
      ty: { previous: 0, current: 0, amt: 0.08 },
      rotation: { previous: 0, current: 0, amt: 0.08 },
      brightness: { previous: 1, current: 1, amt: 0 },
    };

    /* =====================================================
       MENU ITEM CLASS
    ===================================================== */
    class MenuItem {
      constructor(el, position) {
        this.DOM = { el };
        this.inMenuPosition = position;
        this.animatableProperties = JSON.parse(
          JSON.stringify(animatableProperties),
        );

        this.DOM.textInner = this.DOM.el.querySelector(".menu__item-textinner");

        this.layout();
        this.initEvents();
      }

      layout() {
        this.DOM.reveal = document.createElement("div");
        this.DOM.reveal.className = "hover-reveal";

        this.DOM.revealInner = document.createElement("div");
        this.DOM.revealInner.className = "hover-reveal__inner";

        this.DOM.revealImage = document.createElement("div");
        this.DOM.revealImage.className = "hover-reveal__img";
        this.DOM.revealImage.style.backgroundImage = `url(${images[this.inMenuPosition][1]})`;

        this.DOM.revealInner.appendChild(this.DOM.revealImage);
        this.DOM.reveal.appendChild(this.DOM.revealInner);
        this.DOM.el.appendChild(this.DOM.reveal);
      }

      calcBounds() {
        this.bounds = {
          el: this.DOM.el.getBoundingClientRect(),
          reveal: this.DOM.reveal.getBoundingClientRect(),
        };
      }

      initEvents() {
        this.mouseenterFn = () => {
          this.showImage();
          this.firstRAFCycle = true;
          this.loopRender();
        };

        this.mouseleaveFn = () => {
          this.stopRendering();
          this.hideImage();
        };

        this.DOM.el.addEventListener("mouseenter", this.mouseenterFn);
        this.DOM.el.addEventListener("mouseleave", this.mouseleaveFn);
      }

      /* ---------- SHOW ---------- */
      showImage() {
        gsap.killTweensOf(this.DOM.revealInner);
        gsap.killTweensOf(this.DOM.revealImage);

        this.tl = gsap
          .timeline({
            onStart: () => {
              this.DOM.reveal.style.opacity = 1;
              gsap.set(this.DOM.el, { zIndex: images.length });
            },
          })
          .to(this.DOM.revealInner, {
            duration: 0.2,
            ease: "sine.out",
            startAt: { x: direction.x < 0 ? "-100%" : "100%" },
            x: "0%",
          })
          .to(
            this.DOM.revealImage,
            {
              duration: 0.2,
              ease: "sine.out",
              startAt: { x: direction.x < 0 ? "100%" : "-100%" },
              x: "0%",
            },
            0,
          );
      }

      /* ---------- HIDE ---------- */
      hideImage() {
        gsap.killTweensOf(this.DOM.revealInner);
        gsap.killTweensOf(this.DOM.revealImage);

        this.tl = gsap
          .timeline({
            onStart: () => gsap.set(this.DOM.el, { zIndex: 1 }),
            onComplete: () => gsap.set(this.DOM.reveal, { opacity: 0 }),
          })
          .to(this.DOM.revealInner, {
            duration: 0.2,
            ease: "sine.out",
            x: direction.x < 0 ? "100%" : "-100%",
          })
          .to(
            this.DOM.revealImage,
            {
              duration: 0.2,
              ease: "sine.out",
              x: direction.x < 0 ? "-100%" : "100%",
            },
            0,
          );
      }

      loopRender() {
        if (!this.requestId) {
          this.requestId = requestAnimationFrame(() => this.render());
        }
      }

      stopRendering() {
        if (this.requestId) {
          cancelAnimationFrame(this.requestId);
          this.requestId = null;
        }
      }

      render() {
        this.requestId = null;

        if (this.firstRAFCycle) this.calcBounds();

        const mouseDistanceX = clamp(
          Math.abs(mousePosCache.x - mousepos.x),
          0,
          100,
        );

        direction = {
          x: mousePosCache.x - mousepos.x,
          y: mousePosCache.y - mousepos.y,
        };

        mousePosCache = { ...mousepos };

        const props = this.animatableProperties;

        props.tx.current =
          Math.abs(mousepos.x - this.bounds.el.left) -
          this.bounds.reveal.width / 2;

        props.ty.current =
          Math.abs(mousepos.y - this.bounds.el.top) -
          this.bounds.reveal.height / 2;

        props.rotation.current = this.firstRAFCycle
          ? 0
          : map(mouseDistanceX, 0, 100, 0, direction.x < 0 ? 60 : -60);

        props.brightness.current = this.firstRAFCycle
          ? 1
          : map(mouseDistanceX, 0, 100, 1, 4);

        for (const key in props) {
          props[key].previous = this.firstRAFCycle
            ? props[key].current
            : lerp(props[key].previous, props[key].current, props[key].amt);
        }

        gsap.set(this.DOM.reveal, {
          x: props.tx.previous,
          y: props.ty.previous,
          rotation: props.rotation.previous,
          filter: `brightness(${props.brightness.previous})`,
        });

        this.firstRAFCycle = false;
        this.loopRender();
      }
    }

    /* ---------------- INIT ITEMS ---------------- */
    [...DOM.menuItems].forEach((item, pos) => new MenuItem(item, pos));
  });
}

/* =====================================================
   SHOPIFY SAFE INITIALIZATION
===================================================== */

// Initial load
document.addEventListener("DOMContentLoaded", () => {
  initializeMuskIMAGEREVEAL(document);
});

// Theme editor section reload
document.addEventListener("shopify:section:load", (e) => {
  initializeMuskIMAGEREVEAL(e.target);
});

// Close the popup when clicking on the close button
document.addEventListener("DOMContentLoaded", function () {
  const closeBtn = document.querySelector(".search-bar-main .close-popup-btn");
  if (closeBtn) {
    closeBtn.addEventListener("click", function (event) {
      event.preventDefault();
      const popup = document.querySelector(
        ".search-bar-main .fusion-search-popup",
      );
      const toggleLink = document.querySelector(
        ".search-bar-main .header-resource-link.fusion-search-trigger",
      );
      const header = document.querySelector(".musk-main-header");
      if (popup) popup.classList.remove("show");
      if (toggleLink) toggleLink.classList.remove("show");
      if (header) header.classList.remove("remove_transform");
    });
  }
});

// PriceRange
function initializeMuskPriceRange() {
  document.querySelectorAll(".price-range-col").forEach((col) => {
    const rangeInputs = col.querySelectorAll(".range-input input"); // 0 = min, 1 = max
    const priceInputs = col.querySelectorAll(".price-input input"); // 0 = min, 1 = max
    const progressBar = col.querySelector(".slider .progress");
    const priceGap = 50;

    if (rangeInputs.length < 2 || priceInputs.length < 2 || !progressBar)
      return;

    const maxRange = Number(rangeInputs[1].max || 0);

    /* ---------- helper to update bar position ---------- */
    function setBar(minVal, maxVal) {
      progressBar.style.left = (minVal / maxRange) * 100 + "%";
      progressBar.style.right = 100 - (maxVal / maxRange) * 100 + "%";
    }

    /* ---------- PRICE INPUT EVENTS ---------- */
    priceInputs.forEach((input) => {
      input.addEventListener("input", () => {
        const minPrice = Number(priceInputs[0].value);
        const maxPrice = Number(priceInputs[1].value);

        if (maxPrice - minPrice >= priceGap && maxPrice <= maxRange) {
          if (input.classList.contains("input-min")) {
            rangeInputs[0].value = minPrice;
          } else {
            rangeInputs[1].value = maxPrice;
          }
          setBar(minPrice, maxPrice);
        }
      });
    });

    /* ---------- RANGE INPUT EVENTS ---------- */
    rangeInputs.forEach((input) => {
      input.addEventListener("input", () => {
        let minVal = Number(rangeInputs[0].value);
        let maxVal = Number(rangeInputs[1].value);

        if (maxVal - minVal < priceGap) {
          if (input.classList.contains("range-min")) {
            rangeInputs[0].value = maxVal - priceGap;
            minVal = maxVal - priceGap;
          } else {
            rangeInputs[1].value = minVal + priceGap;
            maxVal = minVal + priceGap;
          }
        }

        // Sync numeric inputs and bar
        priceInputs[0].value = minVal;
        priceInputs[1].value = maxVal;
        setBar(minVal, maxVal);
      });
    });

    /* ---------- initial bar position ---------- */
    setBar(Number(rangeInputs[0].value), Number(rangeInputs[1].value));
  });
}
document.addEventListener("DOMContentLoaded", initializeMuskPriceRange);

document.addEventListener("DOMContentLoaded", function () {
  // Initialize Musk Hover Tabs
  function initializeMuskHoverTABS(scope = document) {
    const tabHoverWrappers = scope.querySelectorAll(".tab-hover-wrapper");

    if (!tabHoverWrappers.length) return;

    tabHoverWrappers.forEach((tabHoverWrapper) => {
      const tablinks = tabHoverWrapper.querySelectorAll(".tablinks");
      const tabcontents = tabHoverWrapper.querySelectorAll(".tabcontent");

      if (tablinks.length < 2) return;

      // Prevent duplicate initialization
      if (tabHoverWrapper.classList.contains("tabs-initialized")) return;
      tabHoverWrapper.classList.add("tabs-initialized");

      // Activate second tab by default
      const secondTabLink = tablinks[1];
      activateTab(secondTabLink);

      function activateTab(tablink) {
        const tab_c_id = tablink.dataset.type;

        tablinks.forEach((t) => t.classList.remove("active"));

        tabcontents.forEach((content) => {
          content.classList.remove("active");
          content.style.display = "none";
        });

        tablink.classList.add("active");

        const tabContent = tabHoverWrapper.querySelector("#" + tab_c_id);

        if (tabContent) {
          tabContent.classList.add("active");
          tabContent.style.display = "block";
        }
      }

      tablinks.forEach((tablink) => {
        tablink.addEventListener("mouseover", () => activateTab(tablink));
        tablink.addEventListener("focus", () => activateTab(tablink));
      });
    });
  }

  //
  // Run on normal page load
  //
  // document.addEventListener("DOMContentLoaded", function () {
  //   initializeMuskHoverTABS();
  // });
  initializeMuskHoverTABS();
  //
  // Run when Shopify reloads section in editor
  //
  document.addEventListener("shopify:section:load", function (event) {
    initializeMuskHoverTABS(event.target);
  });

  document.addEventListener("shopify:section:select", function (event) {
    initializeMuskHoverTABS(event.target);
  });

  document.addEventListener("shopify:block:select", function (event) {
    initializeMuskHoverTABS(event.target);
  });

  // Counter animation using IntersectionObserver
  const fusionCounters = document.querySelectorAll(".fusion-counter");
  if (fusionCounters.length) {
    // Animate counter from 0 to target value
    function runCounter(element) {
      let targetValue = parseInt(element.textContent.trim(), 10);
      if (isNaN(targetValue)) targetValue = 0;

      let startTimestamp = null;
      const duration = 3000;

      function step(timestamp) {
        if (!startTimestamp) startTimestamp = timestamp;
        const progress = timestamp - startTimestamp;
        const current = Math.min(
          Math.ceil((progress / duration) * targetValue),
          targetValue,
        );
        element.textContent = current;
        if (progress < duration) {
          window.requestAnimationFrame(step);
        } else {
          element.textContent = targetValue; // Ensure exact final value
        }
      }

      window.requestAnimationFrame(step);
    }

    // IntersectionObserver to trigger animation when visible
    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            runCounter(entry.target);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.5 },
    );

    fusionCounters.forEach((counter) => observer.observe(counter));
  }
});

// ------------text filling on scroll js (only for visible containers to reduce reflow) ------------
function initTextFillingForContainer(containerEl) {
  var normal_color = containerEl.getAttribute("normal_color");
  var active_color = containerEl.getAttribute("active_color");
  if (typeof gsap === "undefined") return;
  gsap.registerPlugin(ScrollTrigger);
  var animatedText = containerEl.querySelector("#animated-text");
  if (!animatedText) return;
  if (!animatedText.hasAttribute("data-processed")) {
    var letters = animatedText.innerText.split("");
    animatedText.innerHTML = "";
    letters.forEach(function (letter) {
      var span = document.createElement("span");
      span.className = "text-fill";
      span.innerText = letter === " " ? "\u00A0" : letter;
      animatedText.appendChild(span);
    });
    animatedText.setAttribute("data-processed", "true");
  }
  var textElements = gsap.utils.toArray(
    containerEl.querySelectorAll(".text-fill"),
  );
  var tl = gsap.timeline({
    scrollTrigger: {
      trigger: animatedText,
      start: "top center",
      end: "bottom center",
      scrub: true,
    },
  });
  textElements.forEach(function (text, index) {
    tl.fromTo(
      text,
      { backgroundSize: "0%", color: normal_color },
      {
        backgroundSize: "100%",
        color: active_color,
        ease: "none",
        delay: index * 0.05,
      },
    );
  });
}

function initializeMuskFillingScroll() {
  var containers = document.querySelectorAll(".text-filling-container");
  if (!containers.length) return;
  if (!("IntersectionObserver" in window)) {
    containers.forEach(function (el) {
      initTextFillingForContainer(el);
    });
    return;
  }
  containers.forEach(function (containerEl) {
    if (containerEl.hasAttribute("data-scroll-fill-inited")) return;
    var observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            containerEl.setAttribute("data-scroll-fill-inited", "true");
            obs.disconnect();
            initTextFillingForContainer(containerEl);
          }
        });
      },
      { root: null, rootMargin: "100px 0px", threshold: 0.01 },
    );
    observer.observe(containerEl);
  });
}
initializeMuskFillingScroll();
// ------------our history js with GSAP animations ---------------
(function () {
  function initializeMuskHistoryTab(scope) {
    var history_wrappers;

    // Limit scope if provided (Shopify editor passes section)
    if (scope) {
      history_wrappers = scope.querySelectorAll(".fusion-our-history-wrapper");
    } else {
      history_wrappers = document.querySelectorAll(
        ".fusion-our-history-wrapper",
      );
    }

    if (!history_wrappers.length) return;

    history_wrappers.forEach(function (wrapper) {
      // Prevent duplicate initialization
      if (wrapper.classList.contains("history-initialized")) return;
      wrapper.classList.add("history-initialized");

      var tabs = wrapper.querySelectorAll(".history-tab");
      var navLinks = wrapper.querySelectorAll(".history-tabs-nav a");
      var navItems = wrapper.querySelectorAll(".history-tabs-nav li");

      if (!tabs.length || !navLinks.length) return;

      var currentTabIndex = 1;

      // Fix if only one tab exists
      if (currentTabIndex >= tabs.length) {
        currentTabIndex = 0;
      }

      // Initial state
      tabs.forEach(function (tab, index) {
        if (index === currentTabIndex) {
          tab.style.display = "flex";

          if (typeof gsap !== "undefined") {
            gsap.set(tab, { opacity: 1 });
          } else {
            tab.style.opacity = "1";
          }
        } else {
          tab.style.display = "none";

          if (typeof gsap !== "undefined") {
            gsap.set(tab, { opacity: 0 });
          } else {
            tab.style.opacity = "0";
          }
        }
      });

      // Set active nav
      navItems.forEach(function (item, index) {
        item.classList.toggle("tab-active", index === currentTabIndex);
      });

      // Tab events
      navLinks.forEach(function (link, index) {
        link.addEventListener("mouseenter", function (event) {
          event.preventDefault();
          switchTab(index);
        });

        link.addEventListener("focus", function (event) {
          event.preventDefault();
          switchTab(index);
        });
      });

      function switchTab(targetIndex) {
        if (targetIndex === currentTabIndex) return;

        var currentTab = tabs[currentTabIndex];
        var targetTab = tabs[targetIndex];

        var currentNavItem = navItems[currentTabIndex];
        var targetNavItem = navItems[targetIndex];

        if (!currentTab || !targetTab) return;

        // Update nav
        currentNavItem.classList.remove("tab-active");
        targetNavItem.classList.add("tab-active");

        if (typeof gsap !== "undefined") {
          var tl = gsap.timeline();

          tl.to(currentTab, {
            opacity: 0,
            duration: 0,
            ease: "power2.out",
            onComplete: function () {
              currentTab.style.display = "none";
            },
          });

          targetTab.style.display = "flex";

          tl.fromTo(
            targetTab,
            { opacity: 0 },
            {
              opacity: 1,
              duration: 0,
              ease: "power2.out",
            },
            "-=0.15",
          );

          // Image animation
          var targetImg = targetTab.querySelector(".history-img img");

          if (targetImg) {
            gsap.fromTo(
              targetImg,
              { scale: 1.1, opacity: 0 },
              {
                scale: 1,
                opacity: 1,
                duration: 0,
                ease: "power2.out",
              },
            );
          }
        } else {
          // Fallback without GSAP

          currentTab.style.opacity = "0";

          setTimeout(function () {
            currentTab.style.display = "none";

            targetTab.style.display = "flex";
            targetTab.style.opacity = "0";

            setTimeout(function () {
              targetTab.style.opacity = "1";
            }, 50);
          }, 300);
        }

        currentTabIndex = targetIndex;
      }
    });
  }

  // ===============================
  // Frontend Load
  // ===============================

  document.addEventListener("DOMContentLoaded", function () {
    initializeMuskHistoryTab(document);
  });

  // ===============================
  // Shopify Theme Editor Support
  // ===============================

  document.addEventListener("shopify:section:load", function (event) {
    initializeMuskHistoryTab(event.target);
  });

  document.addEventListener("shopify:section:select", function (event) {
    initializeMuskHistoryTab(event.target);
  });

  document.addEventListener("shopify:block:select", function (event) {
    initializeMuskHistoryTab(event.target);
  });
})();

//   ----------popup countdown js-------------------
// Stored interval IDs for countdown timers so they can be cleaned up on modal close
window._quickviewCountdownIntervals = [];

function initQuickviewCountdown(container) {
  var root = container || document;
  root.querySelectorAll(".quickview-fusion-countdown").forEach(function (el) {
    var dif_cout = el.getAttribute("dif_cout");
    var endDate = el.getAttribute("end_date");
    var end_massage = el.getAttribute("end_massage");
    var countdownDate = new Date(endDate + " 00:00:00").getTime();

    const updateCountdown = () => {
      const distance = countdownDate - Date.now();
      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
      );
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      var daysEl = document.getElementById(`quickview-days-${dif_cout}`);
      var hoursEl = document.getElementById(`quickview-hours-${dif_cout}`);
      var minutesEl = document.getElementById(`quickview-minutes-${dif_cout}`);
      var secondsEl = document.getElementById(`quickview-seconds-${dif_cout}`);

      if (daysEl) daysEl.textContent = days;
      if (hoursEl) hoursEl.textContent = hours;
      if (minutesEl) minutesEl.textContent = minutes;
      if (secondsEl) secondsEl.textContent = seconds;

      if (distance < 0) {
        clearInterval(interval);
        el.textContent = end_massage;
      }
    };

    const interval = setInterval(updateCountdown, 1000);
    window._quickviewCountdownIntervals.push(interval);
    updateCountdown();
  });
}

function clearQuickviewCountdowns() {
  if (window._quickviewCountdownIntervals) {
    window._quickviewCountdownIntervals.forEach(function (id) {
      clearInterval(id);
    });
    window._quickviewCountdownIntervals = [];
  }
}

// -------quickview on-demand fetch------
// Cache fetched quickview HTML to avoid re-fetching the same product
var quickviewHtmlCache = {};
var isQuickviewLoading = false;

function insertHTMLWithScripts(element, html) {
  element.innerHTML = html;
  element.querySelectorAll("script").forEach(function (oldScript) {
    var newScript = document.createElement("script");
    Array.from(oldScript.attributes).forEach(function (attr) {
      newScript.setAttribute(attr.name, attr.value);
    });
    newScript.textContent = oldScript.textContent;
    oldScript.parentNode.replaceChild(newScript, oldScript);
  });
}

function openQuickviewModal(productUrl, triggerEl) {
  var modal = document.getElementById("quickview-modal-global");
  if (!modal) return;
  if (modal.classList.contains("active") && isQuickviewLoading) return;

  var container = document.getElementById("quickview-content-container");

  // Show modal with skeleton shimmer placeholder immediately
  container.innerHTML =
    '<div class="qv-skeleton">' +
    '<div class="qv-skeleton-img qv-shimmer"></div>' +
    '<div class="qv-skeleton-info">' +
    '<div class="qv-skeleton-line h20 w70 qv-shimmer"></div>' +
    '<div class="qv-skeleton-line w40 qv-shimmer"></div>' +
    '<div class="qv-skeleton-line w90 qv-shimmer"></div>' +
    '<div class="qv-skeleton-line w55 qv-shimmer"></div>' +
    '<div class="qv-skeleton-swatches">' +
    '<div class="qv-skeleton-swatch qv-shimmer"></div>' +
    '<div class="qv-skeleton-swatch qv-shimmer"></div>' +
    '<div class="qv-skeleton-swatch qv-shimmer"></div>' +
    '<div class="qv-skeleton-swatch qv-shimmer"></div>' +
    "</div>" +
    '<div class="qv-skeleton-line h44 w90 qv-shimmer"></div>' +
    "</div>" +
    "</div>";
  modal.classList.add("active", "is-loading");
  document.body.classList.add("overflow-hidden");

  // Store trigger for focus restore
  if (triggerEl) {
    if (!triggerEl.id) triggerEl.id = "modal-trigger-" + Date.now();
    modal.setAttribute("data-trigger-element", triggerEl.id);
  }

  // ESC key support
  var handleEscKey = function (event) {
    if (event.key === "Escape" && modal.classList.contains("active")) {
      closeQuickviewModal();
    }
  };
  modal.escKeyHandler = handleEscKey;
  document.addEventListener("keydown", handleEscKey);

  // Clean product URL
  var cleanUrl = productUrl.split("?")[0];
  var sectionUrl = cleanUrl + "?sections=quickview-content";

  function renderQuickviewContent(html) {
    modal.classList.remove("is-loading");
    var parser = new DOMParser();
    var doc = parser.parseFromString(html, "text/html");
    var content = doc.querySelector(".quickview-content-inner");
    if (content) {
      // Use importNode instead of outerHTML to preserve <template> content
      // (needed for deferred-media, product-model custom elements)
      container.innerHTML = "";
      var imported = document.importNode(content, true);
      container.appendChild(imported);
      // Re-execute scripts so variant JSON etc. work
      container.querySelectorAll("script").forEach(function (oldScript) {
        var newScript = document.createElement("script");
        Array.from(oldScript.attributes).forEach(function (attr) {
          newScript.setAttribute(attr.name, attr.value);
        });
        newScript.textContent = oldScript.textContent;
        oldScript.parentNode.replaceChild(newScript, oldScript);
      });
      // Fix dynamically injected <link> tags with media="print" onload pattern
      // (onload inline handlers don't fire when injected via importNode)
      container
        .querySelectorAll('link[rel="stylesheet"][media="print"]')
        .forEach(function (link) {
          link.media = "all";
        });
    } else {
      container.innerHTML = html;
    }

    // Initialize Swiper sliders for the injected content
    setTimeout(function () {
      if (typeof window.onQuickviewModalOpened === "function") {
        window.onQuickviewModalOpened(modal);
      } else if (typeof window.__fuzionLoadSwiper === "function") {
        window.__fuzionLoadSwiper().then(function () {
          if (typeof window.initQuickviewInModal === "function") {
            window.initQuickviewInModal(modal);
          }
        });
      }
    }, 50);

    // Re-attach media pause listeners
    setTimeout(function () {
      if (typeof window.attachPauseAllMediaToGallerySwipers === "function") {
        window.attachPauseAllMediaToGallerySwipers();
      }
    }, 600);

    // Initialize countdown timers inside the modal
    initQuickviewCountdown(container);

    // Initialize Shopify dynamic payment button for injected content
    if (window.Shopify && window.Shopify.PaymentButton) {
      window.Shopify.PaymentButton.init();
    }

    // Focus trap
    setTimeout(function () {
      if (typeof trapFocus === "function") {
        var closeButton = modal.querySelector(".cls-btn-global");
        var firstFocusable =
          closeButton ||
          modal.querySelector(
            'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
          );
        trapFocus(modal, firstFocusable);
      }
    }, 100);
  }

  // Check cache first
  if (quickviewHtmlCache[cleanUrl]) {
    renderQuickviewContent(quickviewHtmlCache[cleanUrl]);
    return;
  }

  // Fetch product content via Section Rendering API
  isQuickviewLoading = true;
  fetch(sectionUrl)
    .then(function (response) {
      return response.json();
    })
    .then(function (json) {
      var html = json["quickview-content"] || "";
      quickviewHtmlCache[cleanUrl] = html;
      // Only inject if modal is still open (user may have closed it during fetch)
      if (modal.classList.contains("active")) {
        renderQuickviewContent(html);
      }
    })
    .catch(function (err) {
      console.error("Quickview fetch error:", err);
      modal.classList.remove("is-loading");
      container.innerHTML =
        '<p style="text-align:center;padding:40px;">Unable to load product details. Please try again.</p>';
    })
    .finally(function () {
      isQuickviewLoading = false;
    });
}

function closeQuickviewModal() {
  var modal = document.getElementById("quickview-modal-global");
  if (!modal) return;

  if (typeof window.pauseAllMedia === "function") window.pauseAllMedia();
  modal.classList.remove("active", "is-loading");
  document.body.classList.remove("overflow-hidden");

  // Clear countdown timers
  clearQuickviewCountdowns();

  // Restore focus
  var triggerElementId = modal.getAttribute("data-trigger-element");
  var triggerElement = triggerElementId
    ? document.getElementById(triggerElementId)
    : null;
  if (typeof removeTrapFocus === "function") {
    removeTrapFocus(triggerElement);
  } else if (triggerElement) {
    triggerElement.focus();
  }
  modal.removeAttribute("data-trigger-element");

  // Remove ESC handler
  if (modal.escKeyHandler) {
    document.removeEventListener("keydown", modal.escKeyHandler);
    delete modal.escKeyHandler;
  }

  // Clear content after close transition
  setTimeout(function () {
    var container = document.getElementById("quickview-content-container");
    if (container && !modal.classList.contains("active")) {
      container.innerHTML = "";
    }
  }, 300);
}

// Event delegation – single listener for all quickview triggers
document.body.addEventListener("click", function (e) {
  var trigger = e.target.closest(".eye-toggle, .quick_add_trigger");
  if (trigger) {
    e.preventDefault();
    var productUrl = trigger.getAttribute("data-product-url");
    if (productUrl) {
      openQuickviewModal(productUrl, trigger);
    }
    return;
  }

  // Close button or overlay click
  var closeBtn = e.target.closest("#quickview-modal-global .cls-btn-global");
  var overlay = e.target.closest("#quickview-modal-global .popup-overlay");
  if (closeBtn || overlay) {
    e.preventDefault();
    closeQuickviewModal();
  }
});

// -------sizechart toggle------
// ------- OPEN -------
function initializeMuskSIZECHART() {
  var toggles = document.querySelectorAll(".sizechart-toggle");

  toggles.forEach(function (toggle) {
    toggle.addEventListener("click", function (e) {
      e.preventDefault();
      var sizeId = this.getAttribute("data-size-id");
      var sizeChart = document.getElementById(sizeId);
      if (sizeChart) {
        sizeChart.classList.add("active");
        document.body.classList.add("overflow-hidden");

        // Store the trigger element for focus management
        sizeChart._triggerElement = toggle;

        // Set up focus trap using existing trapFocus function
        requestAnimationFrame(function () {
          setTimeout(function () {
            if (typeof trapFocus === "function") {
              var closeButton = sizeChart.querySelector(".cls-btn-global");
              var focusableElement =
                closeButton ||
                sizeChart.querySelector(
                  'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
                );
              if (focusableElement) {
                trapFocus(sizeChart, focusableElement);
                // Ensure focus is set on the close button
                if (closeButton && typeof closeButton.focus === "function") {
                  closeButton.focus();
                }
              } else {
                trapFocus(sizeChart, sizeChart);
              }
            }

            // Add handler to catch tab when focus is still on trigger or outside popup
            var handleTabOutside = function (event) {
              if (event.key !== "Tab") return;
              if (!sizeChart.classList.contains("active")) return;

              var activeElement = document.activeElement;

              // If focus is outside the popup (e.g., still on trigger), move it inside
              if (!sizeChart.contains(activeElement)) {
                event.preventDefault();
                var closeButton = sizeChart.querySelector(".cls-btn-global");
                var firstFocusable =
                  closeButton ||
                  sizeChart.querySelector(
                    'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
                  );
                if (firstFocusable) {
                  firstFocusable.focus();
                }
              }
            };

            sizeChart._tabOutsideHandler = handleTabOutside;
            document.addEventListener("keydown", handleTabOutside, true);
          }, 100);
        });

        // Add ESC key support for closing the popup
        var handleEscKey = function (event) {
          if (
            (event.key === "Escape" || event.keyCode === 27) &&
            sizeChart.classList.contains("active")
          ) {
            event.preventDefault();
            event.stopPropagation();
            closeSizeChartPopup(sizeChart);
          }
        };

        // Store the handler reference for cleanup
        sizeChart.escKeyHandler = handleEscKey;
        document.addEventListener("keydown", handleEscKey);
      }
    });
  });
}

// Helper function to close size chart popup
function closeSizeChartPopup(sizeChart) {
  if (!sizeChart) return;
  sizeChart.classList.remove("active");
  document.body.classList.remove("overflow-hidden");

  // Remove ESC key handler
  if (sizeChart.escKeyHandler) {
    document.removeEventListener("keydown", sizeChart.escKeyHandler);
    sizeChart.escKeyHandler = null;
  }

  // Remove tab outside handler
  if (sizeChart._tabOutsideHandler) {
    document.removeEventListener("keydown", sizeChart._tabOutsideHandler, true);
    sizeChart._tabOutsideHandler = null;
  }

  // Restore focus to trigger element if it exists
  if (
    sizeChart._triggerElement &&
    typeof sizeChart._triggerElement.focus === "function"
  ) {
    sizeChart._triggerElement.focus();
  }
  sizeChart._triggerElement = null;

  // Remove focus trap using existing removeTrapFocus function
  if (typeof removeTrapFocus === "function") {
    removeTrapFocus();
  }
}

initializeMuskSIZECHART();

// ------- CLOSE -------
function initializeMuskPopupSizechartCLS() {
  document.addEventListener("click", function (e) {
    // Check if clicked on close button OR overlay
    if (
      e.target.matches(
        ".PopupModal-sizechart-wrapper .cls-btn-global , .PopupModal-sizechart-wrapper .cls-btn-global i",
      ) ||
      e.target.matches(".PopupModal-sizechart-wrapper .popup-overlay")
    ) {
      e.preventDefault();
      var activePopup = e.target.closest(
        ".PopupModal-sizechart-wrapper.active",
      );
      if (activePopup) {
        closeSizeChartPopup(activePopup);
      }
    }
  });
}
initializeMuskPopupSizechartCLS();

// Open size chart popup
function initializeMuskFEAProdSIZE() {
  var openButtons = document.querySelectorAll(
    ".sizechart_toggle_featured_product",
  );
  openButtons.forEach(function (button) {
    button.addEventListener("click", function (e) {
      e.preventDefault();
      var popup = document.querySelector(".sizechart_featured_product");
      if (popup) {
        popup.classList.add("active");
        document.body.classList.add("overflow-hidden");

        // Store the trigger element for focus management
        popup._triggerElement = button;

        // Set up focus trap using existing trapFocus function
        requestAnimationFrame(function () {
          setTimeout(function () {
            if (typeof trapFocus === "function") {
              var closeButton = popup.querySelector(".cls-btn-global");
              var focusableElement =
                closeButton ||
                popup.querySelector(
                  'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
                );
              if (focusableElement) {
                trapFocus(popup, focusableElement);
                // Ensure focus is set on the close button
                if (closeButton && typeof closeButton.focus === "function") {
                  closeButton.focus();
                }
              } else {
                trapFocus(popup, popup);
              }
            }

            // Add handler to catch tab when focus is still on trigger or outside popup
            var handleTabOutside = function (event) {
              if (event.key !== "Tab") return;
              if (!popup.classList.contains("active")) return;

              var activeElement = document.activeElement;

              // If focus is outside the popup (e.g., still on trigger), move it inside
              if (!popup.contains(activeElement)) {
                event.preventDefault();
                var closeButton = popup.querySelector(".cls-btn-global");
                var firstFocusable =
                  closeButton ||
                  popup.querySelector(
                    'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
                  );
                if (firstFocusable) {
                  firstFocusable.focus();
                }
              }
            };

            popup._tabOutsideHandler = handleTabOutside;
            document.addEventListener("keydown", handleTabOutside, true);
          }, 100);
        });

        // Add ESC key support for closing the popup
        var handleEscKey = function (event) {
          if (
            (event.key === "Escape" || event.keyCode === 27) &&
            popup.classList.contains("active")
          ) {
            event.preventDefault();
            event.stopPropagation();
            closeSizeChartPopup(popup);
          }
        };

        // Store the handler reference for cleanup
        popup.escKeyHandler = handleEscKey;
        document.addEventListener("keydown", handleEscKey);
      }
    });
  });
  // Close size chart popup (both close button and overlay)
  var closeButtons = document.querySelectorAll(
    ".sizechart_featured_product .cls-btn-global, .sizechart_featured_product .popup-overlay",
  );
  closeButtons.forEach(function (button) {
    button.addEventListener("click", function (e) {
      e.preventDefault();
      var popup = document.querySelector(".sizechart_featured_product");
      if (popup) {
        closeSizeChartPopup(popup);
      }
    });
  });
}
initializeMuskFEAProdSIZE();

// Open size chart popup
function initializeMusksizechartproductsingle() {
  var openButtons = document.querySelectorAll(".sizechart_product_information");
  openButtons.forEach(function (button) {
    button.addEventListener("click", function (e) {
      e.preventDefault();
      var popup = document.querySelector(".sizechart_product_d");
      if (popup) {
        popup.classList.add("active");
        document.body.classList.add("overflow-hidden");

        // Store the trigger element for focus management
        popup._triggerElement = button;

        // Set up focus trap using existing trapFocus function
        requestAnimationFrame(function () {
          setTimeout(function () {
            if (typeof trapFocus === "function") {
              var closeButton = popup.querySelector(".cls-btn-global");
              var focusableElement =
                closeButton ||
                popup.querySelector(
                  'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
                );
              if (focusableElement) {
                trapFocus(popup, focusableElement);
                // Ensure focus is set on the close button
                if (closeButton && typeof closeButton.focus === "function") {
                  closeButton.focus();
                }
              } else {
                trapFocus(popup, popup);
              }
            }

            // Add handler to catch tab when focus is still on trigger or outside popup
            var handleTabOutside = function (event) {
              if (event.key !== "Tab") return;
              if (!popup.classList.contains("active")) return;

              var activeElement = document.activeElement;

              // If focus is outside the popup (e.g., still on trigger), move it inside
              if (!popup.contains(activeElement)) {
                event.preventDefault();
                var closeButton = popup.querySelector(".cls-btn-global");
                var firstFocusable =
                  closeButton ||
                  popup.querySelector(
                    'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
                  );
                if (firstFocusable) {
                  firstFocusable.focus();
                }
              }
            };

            popup._tabOutsideHandler = handleTabOutside;
            document.addEventListener("keydown", handleTabOutside, true);
          }, 100);
        });

        // Add ESC key support for closing the popup
        var handleEscKey = function (event) {
          if (
            (event.key === "Escape" || event.keyCode === 27) &&
            popup.classList.contains("active")
          ) {
            event.preventDefault();
            event.stopPropagation();
            closeSizeChartPopup(popup);
          }
        };

        // Store the handler reference for cleanup
        popup.escKeyHandler = handleEscKey;
        document.addEventListener("keydown", handleEscKey);
      }
    });
  });
  // Close size chart popup
  var closeButtons = document.querySelectorAll(
    ".sizechart_product_d .cls-btn-global, .sizechart_product_d .popup-overlay",
  );
  closeButtons.forEach(function (button) {
    button.addEventListener("click", function (e) {
      e.preventDefault();
      var popup = document.querySelector(".sizechart_product_d");
      if (popup) {
        closeSizeChartPopup(popup);
      }
    });
  });
}
initializeMusksizechartproductsingle();

// -------subscribe Popup------
(function () {
  var popupSelector = ".PopupModal-subscribe-wrapper";
  var storageKey = "fusionSubscribePopupNextShowAt";

  function getStoredNextShowAt() {
    try {
      return parseInt(localStorage.getItem(storageKey), 10) || 0;
    } catch (error) {
      return 0;
    }
  }

  function setStoredNextShowAt(value) {
    try {
      localStorage.setItem(storageKey, String(value));
    } catch (error) {}
  }

  function getOpenDelay(popup) {
    var delay = parseInt(popup.getAttribute("section_popup_delay"), 10);
    return Number.isFinite(delay) && delay >= 0 ? delay : 2000;
  }

  function getReopenDelayMs(popup) {
    var days = parseFloat(popup.getAttribute("section_popup_reopen_days"));
    var safeDays = Number.isFinite(days) && days > 0 ? days : 1;

    return safeDays * 24 * 60 * 60 * 1000;
  }

  function openSubscribePopup(popup) {
    popup.classList.add("active");
    document.body.classList.add("overflow-hidden");
  }

  function closeSubscribePopup(popup, rememberClose) {
    popup.classList.remove("active");
    document.body.classList.remove("overflow-hidden");

    if (rememberClose) {
      setStoredNextShowAt(Date.now() + getReopenDelayMs(popup));
    }
  }

  function showSubscribeMessage(form, type, message) {
    var messageEl = form.querySelector("[data-subscribe-popup-message]");
    var emailInput = form.querySelector('input[name="contact[email]"]');

    if (!messageEl) return;

    messageEl.hidden = false;
    messageEl.textContent = message;
    messageEl.className =
      "newsletter-form__message newsletter-form__message--" +
      type +
      " form__message";
    messageEl.setAttribute("role", type === "error" ? "alert" : "status");

    if (emailInput) {
      emailInput.classList.toggle("field__input--error", type === "error");
      if (type === "error") {
        emailInput.setAttribute("aria-invalid", "true");
      } else {
        emailInput.removeAttribute("aria-invalid");
      }
    }
  }

  function getResponseFormMessage(html, formId, selector) {
    var doc = new DOMParser().parseFromString(html, "text/html");
    var responseForm = doc.getElementById(formId);
    var messageEl = responseForm ? responseForm.querySelector(selector) : null;

    return messageEl ? messageEl.textContent.trim() : "";
  }

  function isAlreadySubscribedMessage(message) {
    return /already|taken|subscribed/i.test(message || "");
  }

  function initSubscribeForm(popup) {
    var form = popup.querySelector(
      ".subscribe-popup-form, form#subscribe_customeremail",
    );
    if (!form || form.dataset.subscribePopupAjax === "true") return;

    form.dataset.subscribePopupAjax = "true";
    form.setAttribute("novalidate", "novalidate");

    form.addEventListener(
      "submit",
      function (event) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        if (!form.checkValidity()) {
          form.reportValidity();
          return;
        }

        var submitButton = form.querySelector('button[type="submit"]');
        var successMessage =
          popup.getAttribute("data-success-message") ||
          "Thanks for subscribing";

        if (submitButton) {
          submitButton.disabled = true;
          submitButton.setAttribute("aria-busy", "true");
        }

        fetch(form.action.split("#")[0], {
          method: "POST",
          body: new FormData(form),
          credentials: "same-origin",
          headers: {
            Accept: "text/html",
          },
        })
          .then(function (response) {
            return response.text().then(function (html) {
              return {
                html: html,
                ok: response.ok,
                url: response.url,
              };
            });
          })
          .then(function (result) {
            var serverError = getResponseFormMessage(
              result.html,
              form.id,
              ".newsletter-form__message--error, .errors",
            );
            var serverSuccess = getResponseFormMessage(
              result.html,
              form.id,
              ".newsletter-form__message--success",
            );
            var postedSuccessfully =
              result.url.indexOf("customer_posted=true") !== -1 ||
              Boolean(serverSuccess);

            if (
              serverError &&
              !postedSuccessfully &&
              !isAlreadySubscribedMessage(serverError)
            ) {
              showSubscribeMessage(
                form,
                "error",
                serverError || "Please check your email and try again.",
              );
              return;
            }

            form.reset();
            showSubscribeMessage(
              form,
              "success",
              serverSuccess || successMessage,
            );
            setStoredNextShowAt(Date.now() + getReopenDelayMs(popup));
          })
          .catch(function () {
            showSubscribeMessage(
              form,
              "error",
              "Please check your connection and try again.",
            );
          })
          .finally(function () {
            if (submitButton) {
              submitButton.disabled = false;
              submitButton.removeAttribute("aria-busy");
            }
          });
      },
      true,
    );
  }

  function initializeMuskSubscribePopup() {
    document.querySelectorAll(popupSelector).forEach(function (popup) {
      initSubscribeForm(popup);

      if (popup.dataset.subscribePopupCloseBound !== "true") {
        popup.dataset.subscribePopupCloseBound = "true";
        popup
          .querySelectorAll(".cls-btn-global, .popup-overlay")
          .forEach(function (btn) {
            btn.addEventListener("click", function (event) {
              event.preventDefault();
              closeSubscribePopup(popup, true);
            });
          });
      }

      if (popup.dataset.subscribePopupScheduled === "true") return;
      popup.dataset.subscribePopupScheduled = "true";

      setTimeout(function () {
        if (Date.now() >= getStoredNextShowAt()) {
          openSubscribePopup(popup);
        }
      }, getOpenDelay(popup));
    });
  }

  window.initializeMuskSubscribePopup = initializeMuskSubscribePopup;

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initializeMuskSubscribePopup);
  } else {
    initializeMuskSubscribePopup();
  }

  document.addEventListener(
    "shopify:section:load",
    initializeMuskSubscribePopup,
  );
})();
// address edit
function initializeMuskEditaddress() {
  var toggles = document.querySelectorAll(".editaddress-toggle");
  toggles.forEach(function (toggle) {
    toggle.addEventListener("click", function (e) {
      e.preventDefault();
      var editPopupId = this.getAttribute("data-attr-edit");
      var popup = document.getElementById(editPopupId);
      if (popup) {
        popup.classList.add("active");
      }
      document.body.classList.add("overflow-hidden");
    });
  });
}
initializeMuskEditaddress();

// address edit close
function initializeMuskEditaddressCLS() {
  var closeButtons = document.querySelectorAll(
    ".PopupModal-editaddress-wrapper .cls-btn-global, .PopupModal-editaddress-wrapper .popup-overlay",
  );

  closeButtons.forEach(function (button) {
    button.addEventListener("click", function (e) {
      e.preventDefault();

      // Find the closest popup wrapper to this button
      var popup = button.closest(".PopupModal-editaddress-wrapper");

      if (popup) {
        popup.classList.remove("active");
      }

      document.body.classList.remove("overflow-hidden");
    });
  });
}
initializeMuskEditaddressCLS();

// add new address
function initializeMuskADDNEWaddress() {
  var addButtons = document.querySelectorAll(".addnewaddress-toggle");
  addButtons.forEach(function (button) {
    button.addEventListener("click", function (e) {
      e.preventDefault();
      var popup = document.querySelector(".PopupModal-addnewaddress-wrapper");
      if (popup) {
        popup.classList.add("active");
      }
      document.body.classList.add("overflow-hidden");
    });
  });
}
initializeMuskADDNEWaddress();

// add new address close
function initializeMuskADDNEWaddressCLS() {
  var closeButtons = document.querySelectorAll(
    ".PopupModal-addnewaddress-wrapper .cls-btn-global, .PopupModal-addnewaddress-wrapper .popup-overlay",
  );
  closeButtons.forEach(function (button) {
    button.addEventListener("click", function (e) {
      e.preventDefault();
      var popup = document.querySelector(".PopupModal-addnewaddress-wrapper");
      if (popup) {
        popup.classList.remove("active");
      }
      document.body.classList.remove("overflow-hidden");
    });
  });
}
initializeMuskADDNEWaddressCLS();

//   ----------backToTop button js------------------
function initializeMuskScrolltop() {
  var backToTopButtons = document.querySelectorAll(".fusion-scroll-top");
  if (backToTopButtons.length) {
    var _scrollTopRaf = null;
    window.addEventListener("scroll", function () {
      if (_scrollTopRaf) return;
      _scrollTopRaf = requestAnimationFrame(function () {
        var scrollTop = window.scrollY;
        backToTopButtons.forEach(function (btn) {
          btn.classList.toggle("active", scrollTop > 100);
        });
        _scrollTopRaf = null;
      });
    });
    // Click event to scroll to top
    backToTopButtons.forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      });
    });
  }
}
initializeMuskScrolltop();

// recover password
document.addEventListener("DOMContentLoaded", function () {
  // Hide the recover password form initially
  var recoverForm = document.querySelector("form.fusion_musk_recover_pass");
  if (recoverForm) {
    recoverForm.style.display = "none";
  }
  // Add click listener to the "forget password" link
  var forgetPassLink = document.querySelector("a.fusion_musk_forget_pass");
  if (forgetPassLink) {
    forgetPassLink.addEventListener("click", function (event) {
      event.preventDefault();
      var loginForm = document.querySelector("form.fusion_musk_login_form");
      var recoverForm = document.querySelector("form.fusion_musk_recover_pass");
      if (loginForm) loginForm.style.display = "none";
      if (recoverForm) recoverForm.style.display = "block";
    });
  }
});

/*remove address*/
class RemoveAddress {
  constructor() {
    this.deleteButtons = document.querySelectorAll("a.remove-address-btn");
    if (this.deleteButtons.length === 0) return; // Exit if no remove buttons are found
    this._setupEventListeners();
  }

  _setupEventListeners() {
    this.deleteButtons.forEach((button) => {
      button.addEventListener("click", this._handleDeleteButtonClick);
    });
  }

  _handleDeleteButtonClick = (event) => {
    event.preventDefault(); // Prevent default anchor behavior
    const currentTarget = event.currentTarget;
    const addressId = currentTarget.dataset.addressId;

    if (confirm("Are you sure you want to remove this address?")) {
      // Shopify uses POST with _method='delete' for deletion
      fetch(`/account/addresses/${addressId}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: new URLSearchParams({ _method: "delete" }).toString(),
      })
        .then((response) => {
          if (response.ok) {
            location.reload(); // Reload page to reflect changes
          } else {
            return response.text().then((text) => {
              throw new Error(text || "Failed to remove the address.");
            });
          }
        })
        .catch((error) => {});
    }
  };
}

// Initialize the script for the remove button
document.addEventListener("DOMContentLoaded", () => {
  new RemoveAddress();
});

/*address-country-province-js*/
function initCountryProvinceSelector() {
  // Select all country and province select elements on the page
  const countrySelects = document.querySelectorAll(
    'select[name*="address[country]"], select[id*="cart_country_select"]',
  );

  countrySelects.forEach((countrySelect) => {
    // Find the corresponding province select and its container
    const provinceSelect = countrySelect
      .closest("form")
      ?.querySelector(
        'select[name*="address[province]"], select[id*="shipping-province"]',
      );

    const provinceContainer = provinceSelect
      ? provinceSelect.parentElement
      : null;

    if (!provinceSelect || !provinceContainer) return;

    const updateProvinces = () => {
      const selectedOption = countrySelect.options[countrySelect.selectedIndex];
      if (!selectedOption) return;

      const provincesData = selectedOption.getAttribute("data-provinces");
      const provinces = provincesData ? JSON.parse(provincesData) : [];

      // Clear existing options
      provinceSelect.innerHTML = "";

      if (provinces.length > 0) {
        provinceContainer.style.display = "";

        provinces.forEach((province) => {
          const option = document.createElement("option");
          option.value = province[0]; // province code
          option.textContent = province[1]; // province name
          provinceSelect.appendChild(option);
        });
      } else {
        provinceContainer.style.display = "none";
      }
    };

    // Prevent duplicate listeners
    countrySelect.removeEventListener("change", updateProvinces);
    countrySelect.addEventListener("change", updateProvinces);

    // Initial run
    updateProvinces();
  });
}
document.addEventListener("DOMContentLoaded", () => {
  initCountryProvinceSelector();
});

/*Cart js*/
document.addEventListener("DOMContentLoaded", () => {
  // Select all minus and plus buttons
  var minusButtons = document.querySelectorAll(".cart-quantity-minus-btn");
  var plusButtons = document.querySelectorAll(".cart-quantity-plus-btn");

  // Event listener for minus buttons
  minusButtons.forEach((button) => {
    button.addEventListener("click", () => {
      var qtyInput = button.nextElementSibling;
      let currentQty = parseInt(qtyInput.value, 10);

      if (currentQty > 1) {
        currentQty -= 1;
        updateQuantity(qtyInput, currentQty);
      }
    });
  });

  // Event listener for plus buttons
  plusButtons.forEach((button) => {
    button.addEventListener("click", () => {
      var qtyInput = button.previousElementSibling;
      let currentQty = parseInt(qtyInput.value, 10);

      currentQty += 1;
      updateQuantity(qtyInput, currentQty);
    });
  });

  // Function to update quantity and make API call to Shopify
  function updateQuantity(inputElement, newQty) {
    var itemKey = inputElement.dataset.itemKey; // Shopify line item key
    if (!itemKey) {
      console.error("Item key (data-item-key) not found on input element.");
      return;
    }

    var itemRow = inputElement.closest(".product-cart-table--item");
    if (!itemRow) {
      console.error("Closest item row '.product-cart-table--item' not found.");
      return;
    }

    var priceElements = itemRow.querySelectorAll(".cart-item-total-price");
    var unitPriceElement = itemRow.querySelector(".cart-item-price");

    inputElement.value = newQty;

    fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: itemKey,
        quantity: newQty,
      }),
    })
      .then(async (response) => {
        if (!response.ok) {
          // Try to parse error message
          var errorData = await response.json().catch(() => ({}));
          throw errorData;
        }
        return response.json();
      })
      .then((cart) => {
        // Find the updated line item by key
        var updatedItem = cart.items.find((item) => item.key === itemKey);

        if (!updatedItem) {
          console.warn("Updated item not found in cart response.");
          return;
        }

        // Update total price for the item (usually line_price is in cents)
        var itemTotalPrice = updatedItem.line_price;

        priceElements.forEach((priceElement) => {
          priceElement.textContent = formatPrice(itemTotalPrice);
        });

        if (unitPriceElement) {
          unitPriceElement.textContent = formatPrice(updatedItem.price);
        }

        // Update cart total (make sure this function is implemented)
        updateCartTotalPrice(cart);
      })
      .catch((error) => {
        var productQuantityAvailability = document.querySelector(
          ".product_quantity_availability span",
        );
        if (productQuantityAvailability) {
          productQuantityAvailability.textContent =
            error.message || "Error updating quantity";
        } else {
          console.error(
            "Element '.product_quantity_availability span' not found in the document.",
          );
        }
        console.error("Cart update error:", error);
      });
  }

  // Function to update the total price in the cart immediately
  function updateCartTotalPrice(cart) {
    const totalPriceElements = document.querySelectorAll(".cart-total-price"); // Get all elements with the class .cart-total-price

    // Check if the total price elements exist before updating them
    if (totalPriceElements.length > 0) {
      const totalPrice = cart.items.reduce(
        (total, item) => total + item.line_price,
        0,
      ); // Recalculate total price
      totalPriceElements.forEach((element) => {
        element.textContent = formatPrice(totalPrice); // Update each element with formatted price
      });
    }
  }

  // Function to format price (assuming cents-based prices from Shopify)
  function formatPrice(cents) {
    const currencySymbol = document
      .querySelector(".order--total.cart-total-price.currency-format")
      .getAttribute("data-currency-format");
    return `${currencySymbol}${(cents / 100).toFixed(2)}`; // Format price to dollars (assuming Shopify returns cents-based prices)
  }

  // Initialize cart total price on page load
  fetch("/cart.js")
    .then((response) => response.json())
    .then((cart) => {
      updateCartTotalPrice(cart); // Set initial cart total price
    })
    .catch((error) => {});
});
/*cart-estimate with country*/
function initShippingEstimate() {
  var shippingestimateform = document.getElementById("shipping-estimate-form");

  if (!shippingestimateform) return;

  shippingestimateform.addEventListener("submit", async function (event) {
    event.preventDefault();

    var country = document.getElementById("cart_country_select")?.value;
    var province = document.getElementById("shipping-province")?.value;
    var postalCode = document.getElementById("zipcode")?.value;
    var resultContainer = document.getElementById("shipping-result");

    if (!country || !postalCode) {
      alert("Please provide the required fields (Country and Postal Code).");
      return;
    }

    try {
      var payload = {
        shipping_address: {
          country,
          province: province || null,
          zip: postalCode,
        },
      };

      var response = await fetch("/cart/shipping_rates.json", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(payload),
      });
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }

      var data = await response.json();
      var shippingRates = data.shipping_rates || [];

      let resultHtml = "";

      if (shippingRates.length === 0) {
        resultHtml = `
            <div class="alert alert-warning" role="alert">
              <p>${window.variantStrings.shipping_success_text}</p>
            </div>`;
      } else {
        shippingRates.forEach((rate) => {
          resultHtml += `
              <div class="alert alert-warning" role="alert">
                <p>${rate.name}: $${(rate.price / 100).toFixed(2)}</p>
              </div>`;
        });
      }

      resultContainer.innerHTML = resultHtml;
    } catch (error) {
      resultContainer.innerHTML = `
          <p class="error">
            ${window.variantStrings.shipping_error_text}
          </p>`;
      console.error(error);
    }
  });
}
document.addEventListener("DOMContentLoaded", () => {
  initShippingEstimate();
});

//cart-remove-item js
function removeProductItem(event, element) {
  // Prevent the default link behavior
  event.preventDefault();

  const cartItem = element.closest(".product-item-click-remove");

  if (cartItem) {
    const variantId = cartItem.dataset.variantId;
    cartItem.remove();
    fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        updates: {
          [variantId]: 0,
        },
      }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok " + response.statusText);
        }
        return response.json();
      })
      .then((data) => {
        fetch(location.href)
          .then(function (r) {
            return r.text();
          })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, "text/html");
            var source = doc.querySelector("#product_item_remove");
            var target = document.querySelector("#product_item_remove");
            if (source && target) target.innerHTML = source.innerHTML;
          });
      })
      .catch((error) => {});
  }
}

document.addEventListener("DOMContentLoaded", function () {
  // Loop through all forms containing the address fields
  document.querySelectorAll("form").forEach(function (form) {
    // Handle country select elements within the form
    form
      .querySelectorAll("select[data-address-country-select]")
      .forEach(function (countrySelect) {
        // Get the default country value from the data-default attribute
        const defaultCountry = countrySelect.getAttribute("data-default");

        // Check if defaultCountry is valid
        if (defaultCountry) {
          // Set the selected option in the dropdown based on the default value
          countrySelect.value = defaultCountry;

          // Trigger a change event to load provinces if necessary
          const changeEvent = new Event("change");
          countrySelect.dispatchEvent(changeEvent);
        }
      });

    // Handle provinces loading if there's any dynamic province select logic
    form
      .querySelectorAll('select[name="address[province]"]')
      .forEach(function (provinceSelect) {
        const defaultProvince = provinceSelect.getAttribute("data-default");

        // Check if defaultProvince is valid
        if (defaultProvince) {
          // Set the selected province
          provinceSelect.value = defaultProvince;
        }
      });

    // Handle default address checkbox
    const defaultAddressCheckbox = form.querySelector(
      'input[name="address[default]"]',
    );
    if (defaultAddressCheckbox) {
      const isDefault =
        defaultAddressCheckbox.getAttribute("data-default") === "true";
      defaultAddressCheckbox.checked = isDefault;
    }
  });
});
/*related-product*/
document.addEventListener("DOMContentLoaded", () => {
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement("div");
        html.innerHTML = text;
        const recommendations = html.querySelector(".product-recommendations");

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .catch((e) => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector(
    ".product-recommendations",
  );
  if (!productRecommendationsSection) {
    return;
  }

  const observer = new IntersectionObserver(handleIntersection, {
    rootMargin: "0px 0px 200px 0px",
  });
  observer.observe(productRecommendationsSection);
});

document.addEventListener("DOMContentLoaded", function () {
  const banners = document.querySelectorAll(
    ".musk-main-banner .product_hero_banner_wrapp",
  );
  let currentIndex = 0;
  let progressInterval;

  function activateBanner(index) {
    banners.forEach((banner) => {
      banner.classList.remove("active");
      resetProgressBar(banner);
    });

    setTimeout(() => {
      banners[index].classList.add("active");
      startProgressBar(banners[index]);
    }, 3000);
  }

  function startBannerRotation() {
    activateBanner(currentIndex);
    setInterval(() => {
      currentIndex = (currentIndex + 1) % banners.length;
      activateBanner(currentIndex);
    }, 8000);
  }

  function startProgressBar(activeBanner) {
    clearInterval(progressInterval); // Clear any existing interval
    const progressElement = activeBanner.querySelector(".progress");
    if (!progressElement) return;

    let itemValue = progressElement.dataset.progress || 100;
    progressElement.style.width = "0%";
    progressElement.style.transition = "width 5s linear"; // Smooth transition for progress bar

    setTimeout(() => {
      if (activeBanner.classList.contains("active")) {
        progressElement.style.width = itemValue + "%";
      }
    }, 10);
  }

  function resetProgressBar(banner) {
    const progressElement = banner.querySelector(".progress");
    if (progressElement) {
      progressElement.style.width = "0%";
      progressElement.style.transition = "none"; // Reset transition
    }
  }

  if (banners.length > 0) {
    startBannerRotation();
  }
});

document.addEventListener("DOMContentLoaded", function () {
  // Select all pagination bullets
  const bullets = document.querySelectorAll(
    ".fusion-shoplook-wrapper .custom_pagination_grid .pagination-bullet .details-toggle",
  );
  // Select all shoplook items
  const shoplookItems = document.querySelectorAll(
    ".fusion-shoplook-wrapper .shoplook_item",
  );

  // Function to update active and inactive classes
  function updateActiveItem(targetId) {
    shoplookItems.forEach((item) => {
      if (item.id === targetId) {
        item.classList.add("active");
        item.classList.remove("inactive");
      } else {
        item.classList.remove("active");
        item.classList.add("inactive");
      }
    });
  }

  // Function to clear active and inactive classes
  function clearActiveInactive() {
    shoplookItems.forEach((item) => {
      item.classList.remove("active");
      item.classList.remove("inactive");
    });
  }

  // Add hover (mouseenter) and leave (mouseleave) events to each pagination bullet
  bullets.forEach((bullet) => {
    // Mouse hover
    bullet.addEventListener("mouseenter", function () {
      let targetId = this.getAttribute("data-bullets");
      updateActiveItem(targetId);
    });

    bullet.addEventListener("mouseleave", function () {
      clearActiveInactive();
    });

    // Keyboard focus
    bullet.addEventListener("focus", function () {
      let targetId = this.getAttribute("data-bullets");
      updateActiveItem(targetId);
    });

    bullet.addEventListener("blur", function () {
      clearActiveInactive();
    });
  });
});

// GSAP vertical slide: only init when section is visible; kill only our triggers; defer refresh to reduce reflow
var fusionVideoSlideVerticalTriggers = [];
function createFusionVideoSlideVerticalTriggers() {
  const section = document.querySelector(".fusion_video_slide_vertical");
  if (!section || typeof gsap === "undefined") return;
  gsap.registerPlugin(ScrollTrigger);
  if (typeof ScrollTrigger.config === "function") {
    ScrollTrigger.config({ limitCallbacks: true });
  }
  const cardsWrappers = gsap.utils.toArray(
    ".fusion_video_slide_vertical .card-wrapper",
  );
  const cards = gsap.utils.toArray(".fusion_video_slide_vertical .card");
  const windowWidth = window.innerWidth;
  fusionVideoSlideVerticalTriggers.forEach(function (t) {
    if (t && t.kill) t.kill();
  });
  fusionVideoSlideVerticalTriggers.length = 0;

  let startOffset, endOffset;
  if (windowWidth < 768) {
    startOffset = 80;
    endOffset = 500;
  } else if (windowWidth >= 768 && windowWidth <= 1199) {
    startOffset = 80;
    endOffset = 500;
  } else if (windowWidth >= 1200 && windowWidth <= 1399) {
    startOffset = 130;
    endOffset = 600;
  } else if (windowWidth >= 1400 && windowWidth <= 1540) {
    startOffset = 130;
    endOffset = 600;
  } else if (windowWidth >= 1541 && windowWidth <= 1720) {
    startOffset = 130;
    endOffset = 600;
  } else if (windowWidth >= 1721 && windowWidth <= 1900) {
    startOffset = 130;
    endOffset = 700;
  } else {
    startOffset = 140;
    endOffset = 860;
  }

  cardsWrappers.forEach(function (wrapper, i) {
    const card = cards[i];
    let scale = 1;
    let rotation = 0;

    gsap.set(card, { opacity: 1 });

    var st1 = ScrollTrigger.create({
      trigger: wrapper,
      start: "top " + (startOffset + 10 * i),
      end: "bottom " + endOffset,
      endTrigger: ".fusion_video_slide_vertical .wrapper",
      scrub: true,
      onUpdate: function (self) {
        if (self.progress > 0.1) {
          for (let j = 0; j < i; j++) {
            gsap.to(cards[j], { opacity: 0, duration: 0.3 });
          }
        } else {
          for (let j = 0; j < i; j++) {
            gsap.to(cards[j], { opacity: 1, duration: 0.3 });
          }
        }
      },
      pin: wrapper,
      pinSpacing: false,
    });
    fusionVideoSlideVerticalTriggers.push(st1);

    if (i !== cards.length - 1) {
      scale = 0.8 + 0.025 * i;
      var tween = gsap.to(card, {
        scale: scale,
        rotationX: rotation,
        opacity: 0,
        transformOrigin: "top center",
        ease: "none",
        filter: "blur(" + (1 - scale) * 45 + "px)",
        scrollTrigger: {
          trigger: wrapper,
          start: "top " + (startOffset + 10 * i),
          end: "bottom " + endOffset,
          endTrigger: ".fusion_video_slide_vertical .wrapper",
          scrub: true,
        },
      });
      if (tween.scrollTrigger)
        fusionVideoSlideVerticalTriggers.push(tween.scrollTrigger);
    }
  });

  requestAnimationFrame(function () {
    requestAnimationFrame(function () {
      ScrollTrigger.refresh();
    });
  });
}

function fusionvideoslidevertical() {
  var fusionvideoslideverticala = document.querySelector(
    ".fusion_video_slide_vertical",
  );
  if (fusionvideoslideverticala) {
    createFusionVideoSlideVerticalTriggers();
  }
}

function initFusionVideoSlideVerticalWhenVisible() {
  const section = document.querySelector(".fusion_video_slide_vertical");
  if (!section) return;
  if (!("IntersectionObserver" in window)) {
    fusionvideoslidevertical();
    return;
  }
  var initialized = false;
  var observer = new IntersectionObserver(
    function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !initialized) {
          initialized = true;
          obs.disconnect();
          fusionvideoslidevertical();
        }
      });
    },
    { root: null, rootMargin: "200px 0px", threshold: 0.01 },
  );
  observer.observe(section);
}

var resizeTimeout;
window.addEventListener("resize", function () {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(function () {
    var section = document.querySelector(".fusion_video_slide_vertical");
    if (section && fusionVideoSlideVerticalTriggers.length > 0) {
      createFusionVideoSlideVerticalTriggers();
    }
  }, 200);
});

initFusionVideoSlideVerticalWhenVisible();

// faq collapsible
var faqcollapsible = document.querySelectorAll(".faq_collapsible");
if (faqcollapsible.length > 0) {
  faqcollapsible.forEach(function (sectionEl) {
    var faqs = sectionEl.querySelectorAll(".accordion-item");
    var searchInput = sectionEl.querySelector(".search-input");

    faqs.forEach(function (faq) {
      faq.addEventListener("click", function () {
        faq.classList.toggle("active");
      });
    });

    if (!searchInput) return;

    var filterNoteEl = sectionEl.querySelector(".faq-filter-note");
    var noteTimeout = null;

    function showFilterNote() {
      if (!filterNoteEl) return;
      filterNoteEl.textContent =
        filterNoteEl.getAttribute("data-note") ||
        "This field only filters questions (it does not submit).";
      clearTimeout(noteTimeout);
      noteTimeout = setTimeout(function () {
        filterNoteEl.textContent = "";
      }, 2500);
    }

    function filterFAQs() {
      var searchValue = searchInput.value.toLowerCase();
      faqs.forEach(function (faq) {
        var question =
          faq.querySelector(".accordion-header")?.textContent.toLowerCase() ||
          "";
        var answer =
          faq.querySelector(".accordion-body")?.textContent.toLowerCase() || "";
        var matchesSearch =
          question.includes(searchValue) || answer.includes(searchValue);
        faq.style.display = matchesSearch ? "block" : "none";
      });
    }

    searchInput.addEventListener("input", filterFAQs);
    searchInput.addEventListener("keydown", function (e) {
      if (e.key === "Enter") {
        e.preventDefault();
        showFilterNote();
      }
    });
  });
}

function initHeadingAnimation() {
  const headingContainer = document.getElementById("enlarge_heading");
  const subheadingContainer = document.getElementById("enlarge_subheading");

  if (!headingContainer || !subheadingContainer) return;

  // Store original text before manipulation
  const headingText = headingContainer.textContent.trim();
  const subheadingText = subheadingContainer.textContent.trim();

  // Ensure elements are visible before manipulation (prevent layout shift)
  headingContainer.style.opacity = "1";
  headingContainer.style.visibility = "visible";
  subheadingContainer.style.opacity = "1";
  subheadingContainer.style.visibility = "visible";

  let headingSpans = [];
  let subheadingSpans = [];
  let headingVisible = false;
  let subheadingVisible = false;
  let observer = null;
  let onScroll = null;
  let _throttledHeadingScroll = null;

  // Use requestAnimationFrame to ensure DOM manipulation doesn't block paint
  requestAnimationFrame(function () {
    headingContainer.innerHTML = headingText
      .split(" ")
      .map(
        (word) =>
          `<span>${word
            .split("")
            .map((letter) => `<span>${letter}</span>`)
            .join("")}</span>`,
      )
      .join("");

    subheadingContainer.innerHTML = subheadingText
      .split(" ")
      .map(
        (word) =>
          `<span>${word
            .split("")
            .map((letter) => `<span>${letter}</span>`)
            .join("")}</span>`,
      )
      .join("");

    // Query spans after DOM manipulation
    headingSpans = Array.from(
      document.querySelectorAll(
        ".banner-slide-content .banner-main-title span span",
      ),
    );
    subheadingSpans = Array.from(
      document.querySelectorAll(
        ".banner-slide-content .banner-fancy-sub-head span span",
      ),
    );

    // Set up IntersectionObserver and scroll handler after DOM is ready
    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.target.id === "enlarge_heading") {
            headingVisible = entry.isIntersecting;
          }
          if (entry.target.id === "enlarge_subheading") {
            subheadingVisible = entry.isIntersecting;
          }
        });
      },
      { threshold: 0.1 },
    );

    observer.observe(headingContainer);
    observer.observe(subheadingContainer);

    onScroll = () => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (headingVisible && headingSpans.length > 0) {
        let distance = Math.min(400, Math.max(0, scrollTop / 15));
        headingSpans.forEach((span, index) => {
          let move = (index - headingSpans.length / 2) * distance * 2;
          span.style.transform = `translateX(${move}px)`;
        });
      }

      if (subheadingVisible && subheadingSpans.length > 0) {
        let distance = Math.min(15, Math.max(0, scrollTop / 10));
        subheadingSpans.forEach((span, index) => {
          let move = (index - subheadingSpans.length / 2) * distance * 2;
          span.style.transform = `translateX(${move}px)`;
        });
      }
    };

    var _headingScrollRaf = null;
    _throttledHeadingScroll = function () {
      if (_headingScrollRaf) return;
      _headingScrollRaf = requestAnimationFrame(function () {
        onScroll();
        _headingScrollRaf = null;
      });
    };

    window.addEventListener("scroll", _throttledHeadingScroll);
  });

  // Return cleanup function
  return () => {
    if (_throttledHeadingScroll) {
      window.removeEventListener("scroll", _throttledHeadingScroll);
    }
    if (observer) {
      observer.disconnect();
    }
    headingContainer.innerHTML = headingText;
    subheadingContainer.innerHTML = subheadingText;
  };
}

let destroyAnimation = null;

function handleResponsiveAnimation() {
  if (window.innerWidth > 767) {
    if (!destroyAnimation) {
      destroyAnimation = initHeadingAnimation();
    }
  } else {
    if (destroyAnimation) {
      destroyAnimation();
      destroyAnimation = null;
    }
  }
}

// Defer animation initialization until after LCP to prevent delaying paint
// Use requestIdleCallback with timeout to ensure it runs, or fallback to load event
function initHeadingAnimationDeferred() {
  if (window.innerWidth <= 767) return;

  if ("requestIdleCallback" in window) {
    requestIdleCallback(handleResponsiveAnimation, { timeout: 3000 });
  } else {
    // Fallback: delay until after page load to ensure LCP has occurred
    if (document.readyState === "complete") {
      setTimeout(handleResponsiveAnimation, 100);
    } else {
      window.addEventListener("load", function () {
        setTimeout(handleResponsiveAnimation, 100);
      });
    }
  }
}

// Only set up resize handler immediately, defer animation init
document.addEventListener("DOMContentLoaded", function () {
  initHeadingAnimationDeferred();
});
window.addEventListener("resize", handleResponsiveAnimation);

// scroll add class header (uses cached _headerEl; throttled with rAF)
if (_headerEl && _headerEl.id === "scrolling_down") {
  _headerEl.classList.add("scrolling_upwards_header");
  var _headerDirLastScroll = window.scrollY || 0;
  var _headerDirRaf = null;
  window.addEventListener("scroll", function () {
    if (_headerDirRaf) return;
    _headerDirRaf = requestAnimationFrame(function () {
      var headerscrolld = window.scrollY || 0;
      if (headerscrolld > _headerDirLastScroll && headerscrolld > 200) {
        _headerEl.classList.remove("scrolling_upwards_header");
        _headerEl.classList.add("scrolling_down_header");
      } else if (headerscrolld < _headerDirLastScroll) {
        _headerEl.classList.add("scrolling_upwards_header");
        _headerEl.classList.remove("scrolling_down_header");
      }
      _headerDirLastScroll = headerscrolld;
      _headerDirRaf = null;
    });
  });
}

// Header nav add overlay
var navItems = document.querySelectorAll(
  ".musk-main-header .musk-navbar ul li.nav_li",
);
var headerOverlay = document.querySelector(".header_overlay");
navItems.forEach((navItem) => {
  navItem.addEventListener("mouseenter", () => {
    if (navItem.querySelector(".fusion-submenu")) {
      headerOverlay?.classList.add("active");
    }
  });
  navItem.addEventListener("mouseleave", () => {
    headerOverlay?.classList.remove("active");
  });
});

// update cart-sidebar progress bar
function updateProgressBar() {
  var progressDrawers = document.querySelectorAll(
    ".cart-sidebar .progress_drawer_bar",
  );
  progressDrawers.forEach((drawer) => {
    var progressBar = drawer.querySelector(".progress-bar");
    if (!progressBar) return;
    var valueNow = progressBar.getAttribute("aria-valuenow");
    if (valueNow === null) return;
    var valueWithPercent = valueNow + "%";
    progressBar.style.width = valueWithPercent;
    drawer.style.setProperty("--progress-width--background", valueWithPercent);
  });
}
document.addEventListener("DOMContentLoaded", () => {
  updateProgressBar();
  var targetNode = document.querySelector(".cart-sidebar");
  if (targetNode) {
    var observer = new MutationObserver(() => {
      updateProgressBar();
    });
    observer.observe(targetNode, {
      childList: true,
      subtree: true,
    });
  }
});

// cart notes popups js

document.addEventListener("DOMContentLoaded", function () {
  const cartSidebar = document.querySelector(".cart-sidebar");
  const cartDrawer = document.querySelector(".cart_drawer_modelsmain");

  if (!cartSidebar) return;

  let activeModal = null;
  let escKeyHandler = null;

  // Helper function to get modal elements dynamically
  function getModalElements() {
    return {
      orderNote: cartSidebar.querySelector(".order_note_modal.order_note_dwr"),
      ship: cartSidebar.querySelector(
        ".order_note_modal.estimate_shipping_dwr",
      ),
      disc: cartSidebar.querySelector(".order_note_modal.discount_dwr"),
    };
  }

  // -------------------------------
  // FOCUS TRAP FUNCTION
  // -------------------------------
  function trapFocus(modal) {
    const selectors = `
        a[href], button:not([disabled]), textarea:not([disabled]),
        input:not([disabled]):not([type="hidden"]),
        select:not([disabled]), [tabindex]:not([tabindex="-1"])
      `;

    const focusable = Array.from(modal.querySelectorAll(selectors));
    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    function handleFocus(e) {
      if (!modal.classList.contains("active")) return;

      if (e.key === "Tab") {
        if (e.shiftKey) {
          if (document.activeElement === first) {
            e.preventDefault();
            last.focus();
          }
        } else {
          if (document.activeElement === last) {
            e.preventDefault();
            first.focus();
          }
        }
      }
    }

    modal.addEventListener("keydown", handleFocus);

    // Focus first element when opened
    setTimeout(() => first.focus(), 50);
  }

  // -------------------------------
  // OPEN MODAL
  // -------------------------------
  function openModal(modal) {
    if (!modal) return;
    activeModal = modal;
    modal.classList.add("active");
    // Query for cartDrawer dynamically to get the current element after DOM updates
    const currentCartDrawer = document.querySelector(".cart_drawer_modelsmain");
    if (currentCartDrawer) {
      currentCartDrawer.classList.add("active");
    }
    trapFocus(modal);

    // Add ESC key handler to close modal and prevent cart drawer from closing
    escKeyHandler = function (e) {
      if (e.key === "Escape" || e.keyCode === 27) {
        if (activeModal && activeModal.classList.contains("active")) {
          e.preventDefault();
          e.stopPropagation();
          closeModal(activeModal);
        }
      }
    };
    document.addEventListener("keydown", escKeyHandler, true);
  }

  // -------------------------------
  // CLOSE MODAL
  // -------------------------------
  function closeModal(modal) {
    if (!modal) return;
    modal.classList.remove("active");
    // Query for cartDrawer dynamically to get the current element after DOM updates
    const currentCartDrawer = document.querySelector(".cart_drawer_modelsmain");
    if (currentCartDrawer) {
      currentCartDrawer.classList.remove("active");
    }
    activeModal = null;

    // Remove ESC key handler when modal is closed
    if (escKeyHandler) {
      document.removeEventListener("keydown", escKeyHandler, true);
      escKeyHandler = null;
    }
  }

  // -------------------------------
  // CLICK HANDLER
  // -------------------------------
  cartSidebar.addEventListener("click", function (e) {
    const target = e.target;
    const modals = getModalElements();

    // OPEN
    if (target.closest(".side_drawer_modal_order_note .add-note")) {
      e.preventDefault();
      openModal(modals.orderNote);
    }

    if (target.closest(".side_drawer_modal_estimate_shipping .add-estimate")) {
      e.preventDefault();
      openModal(modals.ship);
    }

    if (target.closest(".side_drawer_modal_discount .add-discount")) {
      e.preventDefault();
      openModal(modals.disc);
    }

    // CLOSE
    if (target.closest(".order_note_modal.order_note_dwr .close")) {
      e.preventDefault();
      closeModal(modals.orderNote);
    }

    if (target.closest(".order_note_modal.estimate_shipping_dwr .close")) {
      e.preventDefault();
      closeModal(modals.ship);
    }

    if (target.closest(".order_note_modal.discount_dwr .close")) {
      e.preventDefault();
      closeModal(modals.disc);
    }
  });
});

// accordion filter collection detail
var acc = document.getElementsByClassName("accordion_filter_collection_detail");
for (var i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function () {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.classList.contains("active")) {
      panel.classList.remove("active");
    } else {
      panel.classList.add("active");
    }
  });
}

// predictive search js start
document.addEventListener("shopify:section:load", initializeSearchFeatures);
document.addEventListener("shopify:section:reorder", initializeSearchFeatures);
document.addEventListener("DOMContentLoaded", initializeSearchFeatures);

function initializeSearchFeatures() {
  initializeSearch();
}

// header search popup
function initializeSearch() {
  const searchInput = document.querySelector("#Search-In-Modal");
  const searchResults = document.querySelector("#search-results");
  if (!searchInput || !searchResults) return;

  // Get fallback image from attribute
  const fallbackImage =
    searchResults.getAttribute("image_url") || "/assets/lifestyle-2.svg";

  // Save default layout once
  if (!window.defaultSearchHTML) {
    window.defaultSearchHTML = searchResults.innerHTML;
  }

  searchInput.addEventListener("input", function () {
    let query = searchInput.value.trim();

    if (query.length > 0) {
      fetch(
        `/search/suggest.json?q=${query}&resources[type]=product,collection,article,page&page=1&limit=10`,
      )
        .then((response) => response.json())
        .then((data) => {
          const products = (data.resources.results.products || []).slice(0, 4);
          const collections = (data.resources.results.collections || []).slice(
            0,
            2,
          );
          const articles = (data.resources.results.articles || []).slice(0, 2);
          const pages = (data.resources.results.pages || []).slice(0, 4);

          let html = `
              <div class="col-lg-8">
                <div class="popular_search_product_header">
                  <div class="search_header_title">
                    <h5>Popular Products</h5>
                    <a href="/collections/all"><span>View all</span></a>
                  </div>
                  <div class="popular_search_product_header_wrapp">
                    <div class="row">
                      ${
                        products.length > 0
                          ? products
                              .map(
                                (product) => `
                                <div class="col-lg-3 col-6 col-sm-6 col-md-6">
                                  <div class="popular_search_product_header_item">
                                    <div class="product-img">
                                      <a href="${product.url}" tabindex="-1">
                                        <img src="${product.image || fallbackImage}" alt="${product.title}" class="img-fluid">
                                      </a>
                                    </div>
                                    <div class="product-detail">
                                      <a href="${product.url}">
                                        <h6 class="product-name">${product.title}</h6>
                                      </a>
                                    </div>
                                  </div>
                                </div>`,
                              )
                              .join("")
                          : `<div class="col-12"><p>No products found</p></div>`
                      }
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4">
                <div class="popular_search_collection_blog">
                  <div class="popular_search_collection_header">
                    <div class="search_header_title">
                      <h5>Collections</h5>
                      <a href="/collections"><span>View all</span></a>
                    </div>
                    ${
                      collections.length > 0
                        ? collections
                            .map(
                              (collection) => `
                              <div class="popular_search_collection_header_item">
                                <a href="${collection.url}">
                                  <h6 class="collection_name">${collection.title}</h6>
                                </a>
                              </div>`,
                            )
                            .join("")
                        : `<p>No collections found</p>`
                    }
                  </div>
                  <div class="popular_search_article_header">
                    <div class="search_header_title">
                      <h5>Latest Articles</h5>
                      <a href="/blogs/all"><span>View all</span></a>
                    </div>
                    <div class="blog_posts_head">
                      <div class="row">
                        ${
                          articles.length > 0
                            ? articles
                                .map(
                                  (article) => `
                                  <div class="col-lg-6 col-6 col-sm-6 col-md-6">
                                    <div class="blog_post_item_header">
                                      <div class="article_img">
                                        <img src="${article.image || fallbackImage}" alt="${article.title}">
                                      </div>
                                      <div class="article_content">
                                        <a href="${article.url}">
                                          <h6 class="article_title heading_color">${article.title}</h6>
                                        </a>
                                      </div>
                                    </div>
                                  </div>`,
                                )
                                .join("")
                            : `<div class="col-12"><p>No articles found</p></div>`
                        }
                      </div>
                    </div>
                  </div>
                  <div class="popular_search_pages_header"> 
                    <div class="search_header_title">
                      <h5>Pages</h5>
                      <a href="/search?q=${encodeURIComponent(query)}&type=page"><span>View all</span></a>
                    </div>
                    <div class="col-lg-2">
                      <div class="pages-grid">
                        ${
                          pages.length > 0
                            ? pages
                                .map(
                                  (page) => `
                                  <div class="page-card">
                                    <a href="${page.url}" class="page-card-link">
                                      <h6 class="page_name h5">${page.title}</h6>
                                    </a>
                                  </div>`,
                                )
                                .join("")
                            : `<p class="no-pages">No pages found</p>`
                        }
                      </div>
                    </div>
                </div>
                </div>
                  
              </div>
            `;

          searchResults.innerHTML = html;
          searchResults.style.display = "flex";
        })
        .catch((error) => {
          console.error("Search Fetch Error:", error);
          searchResults.innerHTML = "<p>Error loading results.</p>";
          searchResults.style.display = "flex";
        });
    } else {
      // Restore default layout without page reload
      searchResults.innerHTML = window.defaultSearchHTML;
    }
  });
}

// hero banner section product popup
document.querySelectorAll(".product-quick-close").forEach(function (btn) {
  btn.addEventListener("click", function () {
    document
      .querySelectorAll(".product_hero_banner_wrapp")
      .forEach(function (el) {
        el.style.display = "none";
      });
  });
});
document.addEventListener("DOMContentLoaded", function () {
  var headerLink = document.querySelector(
    ".header-resource-link.fusion-search-trigger",
  );
  var announcementBar = document.querySelector(".announcement-bar-main.box");

  if (headerLink && announcementBar) {
    headerLink.addEventListener("click", function (e) {
      e.preventDefault(); // optional: prevent link behavior
      announcementBar.classList.toggle("search_clicked");
    });
  }
});
// search bar open
document.querySelectorAll(".search-bar-main").forEach((el) => {
  el.addEventListener("click", () => {
    var overlaycustom = document.querySelector(".fusion-overlay-custom");
    if (overlaycustom) overlaycustom.classList.add("overlay-active");
    document.body.classList.add("overflow-hidden");
  });
});

// search bar close
document.querySelectorAll(".close-popup-btn").forEach((el) => {
  el.addEventListener("click", (e) => {
    e.stopPropagation();
    var overlaycustomc = document.querySelector(".fusion-overlay-custom");
    if (overlaycustomc) overlaycustomc.classList.remove("overlay-active");
    var announcementBarremovec = document.querySelector(
      ".announcement-bar-main.box",
    );
    if (announcementBarremovec) {
      announcementBarremovec.classList.remove("search_clicked");
    }
    document.body.classList.remove("overflow-hidden");
  });
});

//hero banner video load
window.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => {
    const video = document.getElementById("hero-video");
    if (video) {
      video.style.display = "block";
    }
  }, 5000); // delay slightly to allow LCP
});

document
  .querySelectorAll(".jdgm-widget .jdgm-prev-badge__stars")
  .forEach((el) => el.setAttribute("tabindex", "-1"));

document
  .querySelectorAll(".serach--main-tabs-link")
  .forEach((el) => el.setAttribute("tabindex", "0"));

//Recipient-checkbox form hide show
document.addEventListener("DOMContentLoaded", function () {
  // Loop through all recipient checkboxes (in case multiple sections exist)
  const checkboxes = document.querySelectorAll(
    "input[type='checkbox'][id^='Recipient-checkbox-']",
  );

  checkboxes.forEach((checkbox) => {
    const sectionId = checkbox.id.split("Recipient-checkbox-")[1];
    const recipientForm = document.querySelector(
      `recipient-form[data-section-id='${sectionId}'] .recipient-fields`,
    );

    if (!recipientForm) return;

    // Initially hide form
    recipientForm.style.display = "none";

    // Toggle form on checkbox change
    checkbox.addEventListener("change", function () {
      if (checkbox.checked) {
        recipientForm.style.display = "block";
      } else {
        recipientForm.style.display = "none";
      }
    });
  });
});
/*rich-media (performance)*/
/* Click-to-load YouTube/Vimeo embeds to avoid huge upfront JS/CSS on mobile */
function initClickToLoadVideoEmbeds() {
  var embeds = document.querySelectorAll(
    ".fusion-video-embed[data-video-provider][data-video-id]",
  );
  embeds.forEach(function (wrap) {
    if (wrap.getAttribute("data-video-initialized") === "true") return;
    wrap.setAttribute("data-video-initialized", "true");

    var btn = wrap.querySelector(".fusion-video-embed__poster");
    if (!btn) return;

    btn.addEventListener(
      "click",
      function () {
        if (wrap.getAttribute("data-video-loaded") === "true") return;

        try {
          if (typeof window.pauseAllMedia === "function")
            window.pauseAllMedia();
        } catch (e) {}

        var provider = wrap.getAttribute("data-video-provider");
        var id = wrap.getAttribute("data-video-id");
        var loop = wrap.getAttribute("data-video-loop") === "true";
        var title =
          wrap.getAttribute("data-video-title") ||
          (provider === "youtube" ? "YouTube video" : "Vimeo video");

        var src = "";
        if (provider === "youtube") {
          src =
            "https://www.youtube.com/embed/" +
            encodeURIComponent(id) +
            "?enablejsapi=1&autoplay=1&playsinline=1" +
            (loop ? "&loop=1&playlist=" + encodeURIComponent(id) : "");
        } else if (provider === "vimeo") {
          src =
            "https://player.vimeo.com/video/" +
            encodeURIComponent(id) +
            "?autoplay=1" +
            (loop ? "&loop=1" : "");
        } else {
          return;
        }

        var iframe = document.createElement("iframe");
        iframe.src = src;
        iframe.className = provider === "youtube" ? "js-youtube" : "js-vimeo";
        iframe.allow = "autoplay; encrypted-media";
        iframe.allowFullscreen = true;
        iframe.title = title;
        iframe.setAttribute("loading", "lazy");

        wrap.innerHTML = "";
        wrap.appendChild(iframe);
        wrap.setAttribute("data-video-loaded", "true");
      },
      { passive: true },
    );
  });
}

document.addEventListener("DOMContentLoaded", function () {
  initClickToLoadVideoEmbeds();
});
document.addEventListener("shopify:section:load", function () {
  initClickToLoadVideoEmbeds();
});

// ==== product card focus tab js ==== //

document.addEventListener("DOMContentLoaded", () => {
  const overlays = document.querySelectorAll(".product_item_overlay");

  overlays.forEach((overlay) => {
    overlay.addEventListener("focusin", (e) => {
      if (e.target.matches(":focus-visible")) {
        overlay.classList.add("active");
      }
    });

    overlay.addEventListener("focusout", (e) => {
      // Wait for the next frame to ensure focus didn’t move to another element inside
      requestAnimationFrame(() => {
        if (!overlay.contains(document.activeElement)) {
          overlay.classList.remove("active");
        }
      });
    });
  });
});

// ==== Sidebars focus tab js ==== //

document.addEventListener("DOMContentLoaded", function () {
  function trapFocusGlobal(container) {
    const selectors = `
      a[href], area[href],
      input:not([disabled]):not([type="hidden"]),
      select:not([disabled]),
      textarea:not([disabled]),
      button:not([disabled]),
      [tabindex]:not([tabindex="-1"])
    `;

    const getFocusable = () =>
      Array.from(container.querySelectorAll(selectors)).filter(
        (el) => el.offsetParent !== null,
      ); // NEW: ignore hidden elements

    let focusable = getFocusable();
    if (!focusable.length) return;

    let first = focusable[0];
    let last = focusable[focusable.length - 1];

    // ========= CHANGED =========
    function handleKey(e) {
      if (e.key !== "Tab") return;

      // NEW: recalc on every tab (dynamic content safe)
      focusable = getFocusable();
      first = focusable[0];
      last = focusable[focusable.length - 1];

      if (e.shiftKey) {
        if (document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
      } else {
        if (document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }

    // ========= NEW =========
    function handleFocusIn(e) {
      if (!container.contains(e.target)) {
        e.preventDefault();
        first.focus();
      }
    }

    first.focus();

    // ========= CHANGED =========
    document.addEventListener("keydown", handleKey);
    document.addEventListener("focusin", handleFocusIn); // NEW

    // ========= CHANGED =========
    container._release = () => {
      document.removeEventListener("keydown", handleKey);
      document.removeEventListener("focusin", handleFocusIn); // NEW
    };
  }

  /* ---------------------------
        SEARCH POPUP
    --------------------------- */
  const searchPopup = document.querySelector(".fusion-search-popup");
  const searchOpenBtn = document.querySelector(".fusion-search-trigger");
  const searchCloseBtn = searchPopup?.querySelector(".close-popup-btn");

  if (searchPopup) {
    // Store handlers in a closure to survive element replacement
    let searchPopupHandlers = {
      tabHandler: null,
      focusInHandler: null,
      focusOutHandler: null,
    };

    // Store monitoring interval ID for cleanup
    let activeElementCheckInterval = null;

    // Handle ESC key to close popup properly
    function handleEscKey(e) {
      if (e.key === "Escape" || e.keyCode === 27) {
        // Get fresh reference to popup in case it was replaced
        const currentPopup =
          document.querySelector(".fusion-search-popup") ||
          document.querySelector(".fusion-search-popup");
        if (currentPopup && isPopupActive(currentPopup)) {
          e.preventDefault();
          e.stopPropagation();
          // Close the popup properly
          currentPopup.classList.remove("active");
          currentPopup.classList.remove("show");

          // Remove click stopPropagation handler
          if (currentPopup._stopPropagationHandler) {
            currentPopup.removeEventListener(
              "click",
              currentPopup._stopPropagationHandler,
              true,
            );
            currentPopup._stopPropagationHandler = null;
          }

          // Remove focus trap handlers using closure storage
          if (searchPopupHandlers.tabHandler) {
            document.removeEventListener(
              "keydown",
              searchPopupHandlers.tabHandler,
              true,
            );
            searchPopupHandlers.tabHandler = null;
          }
          if (searchPopupHandlers.focusInHandler) {
            document.removeEventListener(
              "focusin",
              searchPopupHandlers.focusInHandler,
              true,
            );
            searchPopupHandlers.focusInHandler = null;
          }
          if (searchPopupHandlers.focusOutHandler && currentPopup) {
            currentPopup.removeEventListener(
              "focusout",
              searchPopupHandlers.focusOutHandler,
            );
            searchPopupHandlers.focusOutHandler = null;
          }
          // Stop activeElement monitoring
          if (activeElementCheckInterval) {
            clearInterval(activeElementCheckInterval);
            activeElementCheckInterval = null;
          }

          const overlay = document.querySelector(".fusion-overlay-custom");
          if (overlay) overlay.classList.remove("overlay-active");
          document.body.classList.remove("overflow-hidden");
          searchOpenBtn?.focus({ preventScroll: true });
        }
      }
    }

    // Helper function to check if popup is active (supports both 'active' and 'show' classes)
    function isPopupActive(modal) {
      return (
        modal &&
        (modal.classList.contains("active") || modal.classList.contains("show"))
      );
    }

    // Separate trapFocus function for search popup - simplified and more robust
    function trapFocus(modal) {
      // Clean up any existing handlers first
      if (searchPopupHandlers.tabHandler) {
        document.removeEventListener(
          "keydown",
          searchPopupHandlers.tabHandler,
          true,
        );
      }
      if (searchPopupHandlers.focusInHandler) {
        document.removeEventListener(
          "focusin",
          searchPopupHandlers.focusInHandler,
          true,
        );
      }
      if (searchPopupHandlers.focusOutHandler && modal) {
        modal.removeEventListener(
          "focusout",
          searchPopupHandlers.focusOutHandler,
        );
      }
      if (activeElementCheckInterval) {
        clearInterval(activeElementCheckInterval);
        activeElementCheckInterval = null;
      }

      const selectors = `
          a[href], button:not([disabled]), textarea:not([disabled]),
          input:not([disabled]):not([type="hidden"]),
          select:not([disabled]), [tabindex]:not([tabindex="-1"])
        `;

      const getFocusable = () => {
        // Get fresh reference to modal in case it was replaced
        const currentModal =
          document.querySelector(".fusion-search-popup") ||
          document.querySelector(".fusion-search-popup");
        if (!currentModal) return [];
        return Array.from(currentModal.querySelectorAll(selectors)).filter(
          (el) => el.offsetParent !== null && !el.disabled,
        ); // ignore hidden and disabled elements
      };

      let focusable = getFocusable();
      if (!focusable.length) {
        return;
      }

      let first = focusable[0];
      let last = focusable[focusable.length - 1];
      let isRedirectingFocus = false;

      function handleTab(e) {
        if (e.key !== "Tab") return;

        // Get fresh reference to modal
        const currentModal =
          document.querySelector(".fusion-search-popup") ||
          document.querySelector(".fusion-search-popup");
        if (!currentModal || !isPopupActive(currentModal)) return;

        // Recalculate focusable elements
        focusable = getFocusable();
        if (!focusable.length) {
          e.preventDefault();
          return;
        }

        first = focusable[0];
        last = focusable[focusable.length - 1];
        const currentFocus = document.activeElement;

        // Only handle if focus is currently inside the modal
        if (!currentModal.contains(currentFocus)) return;

        if (e.shiftKey) {
          // Shift+Tab: going backwards
          if (currentFocus === first) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            last.focus();
            return;
          }
        } else {
          // Tab: going forwards - check if we're on last element
          const currentIndex = focusable.indexOf(currentFocus);
          const isOnLast =
            currentFocus === last || currentIndex === focusable.length - 1;

          if (isOnLast) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            first.focus();
            return;
          }
        }
      }

      // Catch focus escaping - redirect immediately
      function handleFocusIn(e) {
        const currentModal =
          document.querySelector(".fusion-search-popup") ||
          document.querySelector(".fusion-search-popup");
        if (!currentModal || !isPopupActive(currentModal)) return;

        const target = e.target;

        // Allow focus changes inside the modal
        if (currentModal.contains(target)) {
          return;
        }

        // Focus is escaping - redirect immediately
        if (!isRedirectingFocus) {
          isRedirectingFocus = true;
          e.stopPropagation();
          e.stopImmediatePropagation();

          focusable = getFocusable();
          if (focusable.length) {
            focusable[0].focus();
          }

          setTimeout(() => {
            isRedirectingFocus = false;
          }, 10);
        }
      }

      // Monitor activeElement as backup - catch any escapes
      activeElementCheckInterval = setInterval(() => {
        const currentModal =
          document.querySelector(".fusion-search-popup") ||
          document.querySelector(".fusion-search-popup");
        if (!currentModal || !isPopupActive(currentModal)) {
          if (activeElementCheckInterval) {
            clearInterval(activeElementCheckInterval);
            activeElementCheckInterval = null;
          }
          return;
        }

        if (isRedirectingFocus) return;

        const activeElement = document.activeElement;

        // If focus escaped outside modal, bring it back
        if (
          !currentModal.contains(activeElement) &&
          activeElement !== document.body &&
          activeElement !== document.documentElement &&
          activeElement !== null
        ) {
          focusable = getFocusable();
          if (focusable.length) {
            isRedirectingFocus = true;
            focusable[0].focus();
            setTimeout(() => {
              isRedirectingFocus = false;
            }, 10);
          }
        }
      }, 20); // Check every 20ms for very fast response

      // Store handlers
      searchPopupHandlers.tabHandler = handleTab;
      searchPopupHandlers.focusInHandler = handleFocusIn;
      searchPopupHandlers.focusOutHandler = null; // Not using focusout anymore

      // Attach handlers with capture phase
      document.addEventListener("keydown", handleTab, true);
      document.addEventListener("focusin", handleFocusIn, true);

      // Focus first element
      setTimeout(() => {
        const activeModal =
          document.querySelector(".fusion-search-popup") ||
          document.querySelector(".fusion-search-popup");
        if (activeModal && isPopupActive(activeModal)) {
          focusable = getFocusable();
          if (focusable.length) {
            focusable[0].focus();
          }
        }
      }, 100);
    }

    // Use event delegation on document to catch clicks even if button is replaced
    // This ensures the handler works even after Bootstrap or other code replaces the button
    document.addEventListener(
      "click",
      function (e) {
        // Check if click is on the search trigger button (or its children)
        const clickedButton = e.target.closest(".fusion-search-trigger");

        if (clickedButton) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();

          // Get fresh reference to popup in case it was replaced
          const currentPopup =
            document.querySelector(".fusion-search-popup") ||
            document.querySelector(".fusion-search-popup");

          if (currentPopup) {
            currentPopup.classList.add("active");
            currentPopup.classList.add("show"); // Also add 'show' class for compatibility

            // Add overlay classes
            const overlay = document.querySelector(".fusion-overlay-custom");
            if (overlay) {
              overlay.classList.add("overlay-active");
            }
            document.body.classList.add("overflow-hidden");

            // Prevent clicks inside popup from bubbling to overlay handlers
            const stopPropagationHandler = (e) => {
              e.stopPropagation();
            };
            currentPopup.addEventListener(
              "click",
              stopPropagationHandler,
              true,
            );
            currentPopup._stopPropagationHandler = stopPropagationHandler;

            // Attach ESC handler when popup opens (use capture phase to ensure it runs)
            document.addEventListener("keydown", handleEscKey, true);
            currentPopup.addEventListener("keydown", handleEscKey, true);

            // Trap focus - use requestAnimationFrame to ensure popup is rendered
            requestAnimationFrame(() => {
              setTimeout(() => {
                trapFocus(currentPopup);
              }, 50);
            });
          }
        }
      },
      true,
    ); // Use capture phase to catch early

    // Use event delegation for close button too (in case it gets replaced)
    document.addEventListener(
      "click",
      function (e) {
        // Check if click is on the close button (or its children like the icon)
        const clickedCloseBtn = e.target.closest(".close-popup-btn");

        // Also check if we're inside the search popup
        const currentPopup =
          document.querySelector(".fusion-search-popup") ||
          document.querySelector(".fusion-search-popup");

        if (
          clickedCloseBtn &&
          currentPopup &&
          currentPopup.contains(clickedCloseBtn)
        ) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();

          // Close the popup
          currentPopup.classList.remove("active");
          currentPopup.classList.remove("show");

          // Remove overlay classes
          const overlay = document.querySelector(".fusion-overlay-custom");
          if (overlay) {
            overlay.classList.remove("overlay-active");
          }
          document.body.classList.remove("overflow-hidden");

          // Remove click stopPropagation handler
          if (currentPopup._stopPropagationHandler) {
            currentPopup.removeEventListener(
              "click",
              currentPopup._stopPropagationHandler,
              true,
            );
            currentPopup._stopPropagationHandler = null;
          }

          // Remove focus trap handlers using closure storage
          if (searchPopupHandlers.tabHandler) {
            document.removeEventListener(
              "keydown",
              searchPopupHandlers.tabHandler,
              true,
            );
            searchPopupHandlers.tabHandler = null;
          }
          if (searchPopupHandlers.focusInHandler) {
            document.removeEventListener(
              "focusin",
              searchPopupHandlers.focusInHandler,
              true,
            );
            searchPopupHandlers.focusInHandler = null;
          }
          if (searchPopupHandlers.focusOutHandler && currentPopup) {
            currentPopup.removeEventListener(
              "focusout",
              searchPopupHandlers.focusOutHandler,
            );
            searchPopupHandlers.focusOutHandler = null;
          }

          // Stop activeElement monitoring
          if (activeElementCheckInterval) {
            clearInterval(activeElementCheckInterval);
            activeElementCheckInterval = null;
          }

          // Remove ESC handler when popup closes
          document.removeEventListener("keydown", handleEscKey, true);
          if (currentPopup) {
            currentPopup.removeEventListener("keydown", handleEscKey, true);
          }

          // Focus back to open button (preventScroll to avoid mobile scroll-to-top)
          const openBtn = document.querySelector(".fusion-search-trigger");
          if (openBtn) {
            openBtn.focus({ preventScroll: true });
          }
        }
      },
      true,
    ); // Use capture phase

    // Close search popup when clicking the overlay
    document.addEventListener(
      "click",
      function (e) {
        const clickedOverlay = e.target.closest(".fusion-overlay-custom");
        if (!clickedOverlay) return;

        const currentPopup =
          document.querySelector(".fusion-search-popup") ||
          document.querySelector(".fusion-search-popup");
        if (!currentPopup || !isPopupActive(currentPopup)) return;

        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        // Close the popup
        currentPopup.classList.remove("active");
        currentPopup.classList.remove("show");

        // Remove overlay classes
        clickedOverlay.classList.remove("overlay-active");
        document.body.classList.remove("overflow-hidden");

        // Remove click stopPropagation handler
        if (currentPopup._stopPropagationHandler) {
          currentPopup.removeEventListener(
            "click",
            currentPopup._stopPropagationHandler,
            true,
          );
          currentPopup._stopPropagationHandler = null;
        }

        // Remove focus trap handlers using closure storage
        if (searchPopupHandlers.tabHandler) {
          document.removeEventListener(
            "keydown",
            searchPopupHandlers.tabHandler,
            true,
          );
          searchPopupHandlers.tabHandler = null;
        }
        if (searchPopupHandlers.focusInHandler) {
          document.removeEventListener(
            "focusin",
            searchPopupHandlers.focusInHandler,
            true,
          );
          searchPopupHandlers.focusInHandler = null;
        }
        if (searchPopupHandlers.focusOutHandler && currentPopup) {
          currentPopup.removeEventListener(
            "focusout",
            searchPopupHandlers.focusOutHandler,
          );
          searchPopupHandlers.focusOutHandler = null;
        }

        // Stop activeElement monitoring
        if (activeElementCheckInterval) {
          clearInterval(activeElementCheckInterval);
          activeElementCheckInterval = null;
        }

        // Remove ESC handler when popup closes
        document.removeEventListener("keydown", handleEscKey, true);
        currentPopup.removeEventListener("keydown", handleEscKey, true);

        // Focus back to open button (preventScroll to avoid mobile scroll-to-top)
        const openBtn = document.querySelector(".fusion-search-trigger");
        if (openBtn) {
          openBtn.focus({ preventScroll: true });
        }
      },
      true,
    );
  }

  /* ---------------------------
        CART SIDEBAR
    --------------------------- */
  const cartSidebar = document.querySelector(".cart-sidebar");
  const cartOpenBtn = document.querySelector(".cart-btn");
  const cartCloseBtn = cartSidebar?.querySelector(".cart-close-btn");

  if (cartSidebar) {
    cartOpenBtn?.addEventListener("click", () => {
      cartSidebar.classList.add("active");
      trapFocusGlobal(cartSidebar);
    });

    cartCloseBtn?.addEventListener("click", (e) => {
      e.preventDefault();
      cartSidebar.classList.remove("active");
      cartSidebar._release?.();
      cartOpenBtn?.focus({ preventScroll: true });
    });
  }
});

/*----------------------------------------------------------
         COLLECTION TAB FOCUS
  --------------------------------------------------------*/
document.addEventListener("DOMContentLoaded", function () {
  // Select all product list sliders
  const sliders = document.querySelectorAll(".product-list-slider");

  sliders.forEach(function (slider) {
    const tab = slider.querySelector(".product-list-tab");

    if (!tab) return;

    // Add active class when any child gets focus
    slider.addEventListener("focusin", function () {
      tab.classList.add("active");
    });

    // Remove active class when focus leaves the slider
    slider.addEventListener("focusout", function (e) {
      // Check if focus moved outside this slider
      if (!slider.contains(e.relatedTarget)) {
        tab.classList.remove("active");
      }
    });
  });
});

if (!customElements.get("fuzion-variant-options")) {
  customElements.define(
    "fuzion-variant-options",
    class FuzionVariantOptions extends HTMLElement {
      constructor() {
        super();
        this.addEventListener("change", this.onVariantChange);
        this.variantDataPromise = null;
        this.isInitialLoad = true;
      }

      connectedCallback() {
        // Initialize variant data when component is connected to DOM
        this.initializeVariantData();
      }

      async initializeVariantData() {
        // Pre-fetch variant data if needed
        await this.getVariantData();

        // Initialize options array before setting initial variant
        // (needed to prevent null/undefined errors in isOptionAvailable)
        this.updateOptions();

        // Set initial variant and update media/image
        // (this triggers change events which call onVariantChange -> updateOptions)
        await this.setInitialVariant();

        // Update option states after initialization to ensure disabled states are correct
        await this.updateOptionStates();

        // Mark initial load as complete
        this.isInitialLoad = false;
      }

      async setInitialVariant() {
        // Get the initial variant from the JSON script (selected_or_first_available_variant)
        const jsonScript = this.querySelector('[type="application/json"]');
        if (!jsonScript) return;

        try {
          const initialVariantData = JSON.parse(jsonScript.textContent);

          // If it's a single variant object (new format), use it directly
          if (
            initialVariantData &&
            typeof initialVariantData === "object" &&
            !Array.isArray(initialVariantData)
          ) {
            this.currentVariant = initialVariantData;
          } else if (
            Array.isArray(initialVariantData) &&
            initialVariantData.length > 0
          ) {
            // If it's an array (old format), find the selected or first available variant
            this.currentVariant =
              initialVariantData.find((v) => v.selected) ||
              initialVariantData.find((v) => v.available) ||
              initialVariantData[0];
          }

          // Check the radio inputs that match the initial variant's options
          if (this.currentVariant && this.currentVariant.options) {
            const fieldsets = this.querySelectorAll("fieldset");
            fieldsets.forEach((fieldset, fieldsetIndex) => {
              // Get the actual option position for this fieldset (accounts for filtered options)
              const optionPosition =
                this.fieldsetToOptionPosition &&
                this.fieldsetToOptionPosition[fieldsetIndex] !== null
                  ? this.fieldsetToOptionPosition[fieldsetIndex]
                  : fieldsetIndex; // Fallback to fieldsetIndex if mapping not available

              const optionValue = this.currentVariant.options[optionPosition];
              if (optionValue) {
                const matchingInput = fieldset.querySelector(
                  `input[value="${optionValue.replace(/"/g, "&quot;")}"]`,
                );
                if (matchingInput && !matchingInput.checked) {
                  matchingInput.checked = true;
                  // Trigger change event to ensure all handlers are notified
                  matchingInput.dispatchEvent(
                    new Event("change", { bubbles: true }),
                  );
                }
              }
            });
          }

          // Update media/image for the initial variant
          if (this.currentVariant) {
            this.updateMedia();
          }
        } catch (error) {
          console.error("Error setting initial variant:", error);
        }
      }

      async onVariantChange() {
        this.updateOptions();
        await this.updateMasterId();
        await this.updateOptionStates();
        this.updatePickupAvailability();
        this.removeErrorMessage();

        if (!this.currentVariant) {
          this.toggleAddButton(true, "", true);
          this.setUnavailable();
          return;
        } else {
          this.updateVariantStatuses();
          this.updateMedia();
          this.updateURL();
          this.updateVariantInput();
          this.renderProductInfo();
          this.updateShareUrl();
        }
      }

      updateOptions() {
        const fieldsets = Array.from(this.querySelectorAll("fieldset"));
        // Map each fieldset to its option position (since some options may be filtered out)
        this.fieldsetToOptionPosition = fieldsets.map((fieldset) => {
          const firstInput = fieldset.querySelector('input[type="radio"]');
          if (!firstInput) return null;

          // Extract option position from input ID format: "sectionId-optionPosition-index"
          // Option position is 1-based in Shopify, so we need to convert to 0-based
          const idMatch = firstInput.id.match(/-(\d+)-/);
          if (idMatch) {
            return parseInt(idMatch[1], 10) - 1; // Convert to 0-based index
          }

          // Fallback: try to get from name attribute or use fieldset index
          return null;
        });

        this.options = fieldsets.map((fieldset) => {
          const checkedInput = Array.from(
            fieldset.querySelectorAll("input"),
          ).find((radio) => radio.checked);
          return checkedInput ? checkedInput.value : null;
        });
      }

      async updateMasterId() {
        const variants = await this.getVariantData();
        this.currentVariant = variants.find((variant) => {
          return !variant.options
            .map((option, index) => {
              return this.options[index] === option;
            })
            .includes(false);
        });
      }

      updateMedia() {
        if (!this.currentVariant) return;
        if (!this.currentVariant.featured_media) return;

        const mediaGalleries = document.querySelectorAll(
          `#MediaGallery-${this.dataset.section}`,
        );
        mediaGalleries.forEach((mediaGallery) => {
          if (mediaGallery.setActiveMedia) {
            mediaGallery.setActiveMedia(
              this.currentVariant.featured_media.id,
              false,
            );
            // setActiveMedia has no viewer in quickview context; slide the Swiper directly
            mediaGallery
              .querySelectorAll(".swiper-container, .swiper")
              .forEach((swiperEl) => {
                if (!swiperEl.swiper) return;
                const targetSlide = swiperEl.querySelector(
                  `[data-media-id="${this.currentVariant.featured_media.id}"]`,
                );
                if (!targetSlide) return;
                const slides = swiperEl.querySelectorAll(".swiper-slide");
                const idx = Array.from(slides).indexOf(targetSlide);
                if (idx >= 0) swiperEl.swiper.slideTo(idx);
              });
          } else {
            // Fallback for custom galleries
            const currentActive = mediaGallery.querySelector(
              ".product__media-item.is-active",
            );
            const newActive = mediaGallery.querySelector(
              `[data-media-id="${this.currentVariant.featured_media.id}"]`,
            );

            if (currentActive && newActive && currentActive !== newActive) {
              currentActive.classList.remove("is-active");
              newActive.classList.add("is-active");

              // For sliders, update the active slide
              const swiperContainer = newActive.closest(
                ".swiper-container, .swiper",
              );
              if (swiperContainer) {
                const slides =
                  swiperContainer.querySelectorAll(".swiper-slide");
                const activeIndex = Array.from(slides).indexOf(newActive);

                // If swiper is initialized, go to slide
                if (swiperContainer.swiper && activeIndex >= 0) {
                  swiperContainer.swiper.slideTo(activeIndex);
                }
              }

              // Also handle mobile slider specifically
              const mobileSlider = newActive.closest(".mobile_pdp_slider");
              if (mobileSlider) {
                const mobileSlides =
                  mobileSlider.querySelectorAll(".swiper-slide");
                const mobileActiveIndex =
                  Array.from(mobileSlides).indexOf(newActive);

                if (mobileSlider.swiper && mobileActiveIndex >= 0) {
                  mobileSlider.swiper.slideTo(mobileActiveIndex);
                }
              }
            }
          }
        });

        // Additional comprehensive Swiper handling - find all Swiper instances and update the one with the matching media
        const sectionEl =
          document.getElementById(`shopify-section-${this.dataset.section}`) ||
          this.closest("section") ||
          this;
        const allSwipers = sectionEl.querySelectorAll(
          ".swiper-container, .swiper",
        );
        allSwipers.forEach((swiperElement) => {
          if (swiperElement.swiper) {
            const swiperInstance = swiperElement.swiper;
            const targetSlide = swiperElement.querySelector(
              `[data-media-id="${this.currentVariant.featured_media.id}"]`,
            );
            if (targetSlide) {
              const allSlides = swiperElement.querySelectorAll(".swiper-slide");
              const slideIndex = Array.from(allSlides).indexOf(targetSlide);

              if (slideIndex >= 0) {
                // Swiper.js handles loop mode automatically with slideTo
                swiperInstance.slideTo(slideIndex);

                // Update active states for this swiper
                allSlides.forEach((slide) =>
                  slide.classList.remove("is-active"),
                );
                targetSlide.classList.add("is-active");
              }
            }
          }
        });

        const modalContent = document.querySelector(
          `#ProductModal-${this.dataset.section} .product-media-modal__content`,
        );
        if (!modalContent) return;
        const newMedia = modalContent.querySelector(
          `[data-media-id="${this.currentVariant.featured_media.id}"]`,
        );
        if (newMedia) modalContent.prepend(newMedia);
      }

      updateURL() {
        if (!this.currentVariant || this.dataset.updateUrl === "false") return;
        window.history.replaceState(
          {},
          "",
          `${this.dataset.url}?variant=${this.currentVariant.id}`,
        );
      }

      updateShareUrl() {
        const shareButton = document.getElementById(
          `Share-${this.dataset.section}`,
        );
        if (!shareButton || !shareButton.updateUrl) return;
        shareButton.updateUrl(
          `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`,
        );
      }

      updateVariantInput() {
        const productForms = document.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`,
        );
        productForms.forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = this.currentVariant.id;
          input.dispatchEvent(new Event("change", { bubbles: true }));
        });
      }

      updateVariantStatuses() {
        if (!this.currentVariant) return;
        const productForm = document.querySelector(
          `#product-form-${this.dataset.section}`,
        );
        const addButton =
          productForm?.querySelector('[type="submit"]') ||
          document.getElementById(
            `ProductSubmitButton-${this.dataset.section}`,
          );

        if (!addButton) return;

        // Try to find a span element first, otherwise update button textContent directly
        let addButtonText = addButton.querySelector("span");

        if (this.currentVariant && this.currentVariant.available) {
          const text = window.variantStrings?.addToCart || "Add to cart";
          if (addButtonText) {
            addButtonText.textContent = text;
          } else {
            // Update button textContent while preserving child elements (like loading spinner)
            const childElements = Array.from(addButton.children);
            addButton.textContent = text;
            // Re-append child elements (like loading spinner)
            childElements.forEach((child) => addButton.appendChild(child));
          }
          addButton.removeAttribute("disabled");
        } else if (this.currentVariant && !this.currentVariant.available) {
          const text = window.variantStrings?.soldOut || "Sold out";
          if (addButtonText) {
            addButtonText.textContent = text;
          } else {
            // Update button textContent while preserving child elements (like loading spinner)
            const childElements = Array.from(addButton.children);
            addButton.textContent = text;
            // Re-append child elements (like loading spinner)
            childElements.forEach((child) => addButton.appendChild(child));
          }
          addButton.setAttribute("disabled", "disabled");
        }
      }

      updatePickupAvailability() {
        const pickUpAvailability = document.querySelector(
          "pickup-availability",
        );
        if (!pickUpAvailability) return;

        if (this.currentVariant && this.currentVariant.available) {
          pickUpAvailability.fetchAvailability(this.currentVariant.id);
        } else {
          pickUpAvailability.removeAttribute("available");
          pickUpAvailability.innerHTML = "";
        }
      }

      removeErrorMessage() {
        const section = this.closest("section");
        if (!section) return;

        const productForm = section.querySelector("product-form");
        if (productForm) productForm.handleErrorMessage();
      }

      renderProductInfo() {
        if (!this.currentVariant) return;
        const requestedVariantId = this.currentVariant.id;
        const sectionId = this.dataset.originalSection || this.dataset.section;

        // For quickview popups, use a dedicated section for fetching
        const isQuickview =
          this.dataset.section && this.dataset.section.startsWith("quickview-");
        const fetchSectionId = isQuickview
          ? "quickview-product-info"
          : sectionId;

        fetch(
          `${this.dataset.url}?variant=${requestedVariantId}&section_id=${fetchSectionId}`,
          {
            headers: {
              "Cache-Control": "no-cache",
            },
          },
        )
          .then((response) => {
            if (!response.ok) {
              console.error(
                "Failed to fetch product info:",
                response.status,
                response.statusText,
              );
            }
            return response.text();
          })
          .then((responseText) => {
            if (this.currentVariant.id !== requestedVariantId) return;

            const html = new DOMParser().parseFromString(
              responseText,
              "text/html",
            );
            const destination = document.getElementById(
              `price-${this.dataset.section}`,
            );
            const source = html.getElementById(`price-${fetchSectionId}`);

            if (!source) {
              console.warn(
                "Could not find price element in fetched HTML. Looking for:",
                `price-${fetchSectionId}`,
              );
              console.log(
                "Available price elements:",
                Array.from(html.querySelectorAll('[id^="price-"]')).map(
                  (el) => el.id,
                ),
              );
            }

            const skuSource = html.getElementById(`Sku-${fetchSectionId}`);
            const skuDestination = document.getElementById(
              `Sku-${this.dataset.section}`,
            );
            const inventorySource = html.getElementById(
              `Inventory-${fetchSectionId}`,
            );
            const inventoryDestination = document.getElementById(
              `Inventory-${this.dataset.section}`,
            );

            if (source && destination) {
              destination.innerHTML = source.innerHTML;
            }
            if (inventorySource && inventoryDestination)
              inventoryDestination.innerHTML = inventorySource.innerHTML;
            if (skuSource && skuDestination) {
              skuDestination.innerHTML = skuSource.innerHTML;
              skuDestination.classList.toggle(
                "visibility-hidden",
                skuSource.classList.contains("visibility-hidden"),
              );
            }

            const price = document.getElementById(
              `price-${this.dataset.section}`,
            );
            if (price) price.classList.remove("visibility-hidden");

            if (inventoryDestination && inventorySource)
              inventoryDestination.classList.toggle(
                "visibility-hidden",
                inventorySource.innerText === "",
              );

            const addButtonUpdated = html
              .getElementById(`product-form-${this.dataset.section}`)
              ?.querySelector(
                ".product-form__buttons button .loading-overlay__spinner",
              );
            const addButton = document
              .getElementById(`product-form-${this.dataset.section}`)
              ?.querySelector(
                ".product-form__buttons button .loading-overlay__spinner",
              );
            if (addButton && addButtonUpdated)
              addButton.innerHTML = addButtonUpdated.innerHTML;

            if (window.PubSub) {
              window.PubSub.publish(window.PUB_SUB_EVENTS.variantChange, {
                data: {
                  sectionId,
                  html,
                  variant: this.currentVariant,
                },
              });
            }
          });
      }

      toggleAddButton(disable = true, text, modifyClass = true) {
        const productForm = document.getElementById(
          `product-form-${this.dataset.section}`,
        );
        if (!productForm) return;

        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"]');
        if (!addButton) return;

        if (disable) {
          addButton.setAttribute("disabled", "disabled");
          if (text) addButtonText.textContent = text;
        } else {
          addButton.removeAttribute("disabled");
          addButtonText.textContent = window.variantStrings.addToCart;
        }

        if (!modifyClass) return;
      }

      setUnavailable() {
        const productForm = document.querySelector(
          `#product-form-${this.dataset.section}`,
        );
        const button =
          productForm?.querySelector('[name="add"]') ||
          document.getElementById(
            `ProductSubmitButton-${this.dataset.section}`,
          );
        const price = document.getElementById(`price-${this.dataset.section}`);
        const inventory = document.getElementById(
          `Inventory-${this.dataset.section}`,
        );
        const sku = document.getElementById(`Sku-${this.dataset.section}`);
        const pricePerItem = document.getElementById(
          `Price-Per-Item-${this.dataset.section}`,
        );

        if (!button) return;

        // Try to find a span element first, otherwise update button textContent directly
        const addButtonText = button.querySelector("span");
        const unavailableText =
          window.variantStrings?.unavailable || "Unavailable";

        if (addButtonText) {
          addButtonText.textContent = unavailableText;
        } else {
          // Update button textContent while preserving child elements (like loading spinner)
          const childElements = Array.from(button.children);
          button.textContent = unavailableText;
          // Re-append child elements (like loading spinner)
          childElements.forEach((child) => button.appendChild(child));
        }

        button.setAttribute("disabled", "disabled");

        if (price) price.classList.add("visibility-hidden");
        if (inventory) inventory.classList.add("visibility-hidden");
        if (sku) sku.classList.add("visibility-hidden");
        if (pricePerItem) pricePerItem.classList.add("visibility-hidden");
      }

      async updateOptionStates() {
        const variants = await this.getVariantData();
        const fieldsets = this.querySelectorAll("fieldset");
        fieldsets.forEach((fieldset, fieldsetIndex) => {
          const inputs = fieldset.querySelectorAll('input[type="radio"]');
          // Get the actual option position for this fieldset (accounts for filtered options)
          const optionPosition =
            this.fieldsetToOptionPosition &&
            this.fieldsetToOptionPosition[fieldsetIndex] !== null
              ? this.fieldsetToOptionPosition[fieldsetIndex]
              : fieldsetIndex; // Fallback to fieldsetIndex if mapping not available

          inputs.forEach((input) => {
            const optionValue = input.value;
            const shouldDisable = !this.isOptionAvailable(
              optionPosition,
              optionValue,
              variants,
            );

            // Get parent li element (variant--item)
            const parentLi = input.closest(".variant--item");
            // Get associated label
            const label =
              input.nextElementSibling &&
              input.nextElementSibling.tagName === "LABEL"
                ? input.nextElementSibling
                : fieldset.querySelector(`label[for="${input.id}"]`);

            if (shouldDisable) {
              input.classList.add("disabled");
              if (parentLi) parentLi.classList.add("disabled");
              if (label) label.classList.add("disabled");
            } else {
              input.classList.remove("disabled");
              if (parentLi) parentLi.classList.remove("disabled");
              if (label) label.classList.remove("disabled");
            }
          });
        });
      }

      getSelectedOptionValue(optionPosition) {
        // Get the selected value for a given option position
        // Need to map from option position to fieldset index
        if (!this.fieldsetToOptionPosition || !this.options) {
          return null;
        }

        const fieldsetIndex = this.fieldsetToOptionPosition.findIndex(
          (pos) => pos === optionPosition,
        );
        if (fieldsetIndex >= 0 && fieldsetIndex < this.options.length) {
          return this.options[fieldsetIndex];
        }
        return null;
      }

      isOptionAvailable(optionPosition, optionValue, variants) {
        if (!variants || !Array.isArray(variants)) {
          return true; // Default to available if we don't have variant data yet
        }

        // Ensure options array is initialized
        if (!this.options || !Array.isArray(this.options)) {
          this.updateOptions();
        }

        return variants.some((variant) => {
          if (!variant.available) return false;

          // Check if variant has options array
          if (!variant.options || !Array.isArray(variant.options)) {
            return false;
          }

          // Check if this variant matches the option value we're testing
          if (variant.options[optionPosition] !== optionValue) return false;

          // Always only check options that come before the current position
          // This allows showing all valid combinations based on what's already selected
          // For example: if Size=M is selected, show all colors that have M variants
          // Don't filter based on options that come after (they haven't been selected yet)
          for (let i = 0; i < optionPosition; i++) {
            const currentSelectedValue = this.getSelectedOptionValue(i);
            if (
              currentSelectedValue != null &&
              variant.options[i] !== currentSelectedValue
            ) {
              return false;
            }
          }

          return true;
        });
      }

      async getVariantData() {
        // Return cached data if available
        if (this.variantData && Array.isArray(this.variantData)) {
          return this.variantData;
        }

        // If we're already fetching, return the promise
        if (this.variantDataPromise) {
          return await this.variantDataPromise;
        }

        // Start fetching
        this.variantDataPromise = this.loadVariantData();
        return await this.variantDataPromise;
      }

      // Synchronous getter for already-loaded variant data (for backward compatibility)
      getVariantDataSync() {
        // Return cached data if available, otherwise return empty array
        if (this.variantData && Array.isArray(this.variantData)) {
          return this.variantData;
        }
        return [];
      }

      async loadVariantData() {
        const jsonScript = this.querySelector('[type="application/json"]');
        if (!jsonScript) {
          this.variantData = [];
          return this.variantData;
        }

        const parsedData = JSON.parse(jsonScript.textContent);

        // Check if we have an array (old format) or single object (new format)
        if (Array.isArray(parsedData)) {
          this.variantData = parsedData;
          return this.variantData;
        }

        // If it's a single variant object, fetch all variants from product JSON
        if (parsedData && typeof parsedData === "object") {
          return await this.fetchAllVariants();
        }

        this.variantData = [];
        return this.variantData;
      }

      async fetchAllVariants() {
        if (this.variantData) {
          return this.variantData;
        }

        try {
          // Extract product handle from data-url
          const productUrl = this.dataset.url;
          if (!productUrl) {
            console.warn("fuzion-variant-options: No product URL found");
            return [];
          }

          // Extract handle from URL (e.g., /products/my-product -> my-product)
          const urlMatch = productUrl.match(/\/products\/([^?#]+)/);
          if (!urlMatch || !urlMatch[1]) {
            console.warn(
              "fuzion-variant-options: Could not extract product handle from URL:",
              productUrl,
            );
            return [];
          }

          const productHandle = urlMatch[1];

          // Fetch product data from Shopify's JSON endpoint
          const response = await fetch(`/products/${productHandle}.js`);
          if (!response.ok) {
            console.error(
              "fuzion-variant-options: Failed to fetch product data:",
              response.status,
            );
            return [];
          }

          const product = await response.json();

          // Store all variants
          this.variantData = product.variants || [];
          return this.variantData;
        } catch (error) {
          console.error(
            "fuzion-variant-options: Error fetching variants:",
            error,
          );
          return [];
        }
      }
    },
  );
}

// deferred media (product-information: native video, external_video iframe, model use deferred-media only for model)

(function () {
  // Single source of truth for pausing all media – matches product-information.liquid: video, .js-youtube, .js-vimeo, product-model
  window.pauseAllMedia = function () {
    var doc = document;
    [].forEach.call(doc.querySelectorAll("video"), function (v) {
      try {
        v.pause();
      } catch (e) {}
    });
    [].forEach.call(
      doc.querySelectorAll('.js-youtube, iframe[src*="youtube.com/embed"]'),
      function (el) {
        if (el.contentWindow) {
          try {
            el.contentWindow.postMessage(
              '{"event":"command","func":"pauseVideo","args":""}',
              "*",
            );
          } catch (e) {}
        }
      },
    );
    [].forEach.call(
      doc.querySelectorAll('.js-vimeo, iframe[src*="player.vimeo.com"]'),
      function (el) {
        if (el.contentWindow) {
          try {
            el.contentWindow.postMessage('{"method":"pause"}', "*");
          } catch (e) {}
        }
      },
    );
    [].forEach.call(doc.querySelectorAll("product-model"), function (m) {
      if (m.modelViewerUI) {
        try {
          m.modelViewerUI.pause();
        } catch (e) {}
      }
    });
  };

  class DeferredMedia extends HTMLElement {
    constructor() {
      super();
      // If autoplay-true class is present, use IntersectionObserver to auto-load
      if (this.classList.contains("autoplay-true")) {
        this.addObserver();
      } else {
        // Otherwise, load on poster button click
        var poster = this.querySelector('[id^="Deferred-Poster-"]');
        if (poster)
          poster.addEventListener("click", this.loadContent.bind(this));
      }
    }

    addObserver() {
      if (typeof IntersectionObserver === "undefined") {
        this.loadContent();
        return;
      }

      var self = this;
      // IntersectionObserver fires immediately for already-visible elements,
      // so no getBoundingClientRect pre-check needed (avoids forced reflow).
      // A generous rootMargin ensures off-screen elements also pre-load early.
      var rootMargin = this.classList.contains("autoplay-true")
        ? "200px 0px 2000px 0px"
        : "200px 0px 1000px 0px";
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              self.loadContent();
              observer.unobserve(self);
            }
          });
        },
        { rootMargin: rootMargin },
      );
      observer.observe(this);
    }

    loadContent(focus) {
      if (focus === undefined) focus = true;
      if (this.getAttribute("loaded")) return;
      if (typeof window.pauseAllMedia === "function") window.pauseAllMedia();
      var template = this.querySelector("template");
      if (!template) return;
      // template.content.firstElementChild can be null when the HTML was injected via innerHTML
      // (e.g. Shopify Section Rendering / quickview), causing the browser to store the iframe
      // as a text node instead of a parsed element. Fall back to parsing template.innerHTML.
      var deferredElement;
      if (template.content && template.content.firstElementChild) {
        // Normal path: template content was parsed correctly into element nodes
        var content = document.createElement("div");
        content.appendChild(template.content.firstElementChild.cloneNode(true));
        deferredElement = content.querySelector("video, model-viewer, iframe");
      } else {
        // Fallback: template content is stored as a text node (happens when HTML is injected via innerHTML,
        // e.g. Shopify Section Rendering / quickview). textContent gives the raw unescaped HTML string.
        var rawHTML =
          template.content && template.content.textContent
            ? template.content.textContent.trim()
            : template.innerHTML;
        var fallbackDiv = document.createElement("div");
        fallbackDiv.innerHTML = rawHTML;
        deferredElement = fallbackDiv.querySelector(
          "video, model-viewer, iframe",
        );
      }
      this.setAttribute("loaded", true);
      if (deferredElement) {
        this.appendChild(deferredElement);
        if (focus) deferredElement.focus();
        // Hide poster for all types (iframe = YouTube/Vimeo, video = native) so thumbnail is replaced by loaded media
        var posterBtn = this.querySelector('[id^="Deferred-Poster-"]');
        if (posterBtn) posterBtn.style.display = "none";
        // Handle iframe (YouTube/Vimeo): add autoplay=1 so video plays immediately on poster click
        if (deferredElement.nodeName === "IFRAME") {
          var iframeSrc = deferredElement.src || "";
          if (iframeSrc && iframeSrc.indexOf("autoplay=") === -1) {
            var sep = iframeSrc.indexOf("?") !== -1 ? "&" : "?";
            deferredElement.src = iframeSrc + sep + "autoplay=1";
          }
        }
        // Handle native video: play on first interaction (click or autoplay when in view)
        if (deferredElement.nodeName === "VIDEO") {
          // Required for programmatic play in most browsers
          if (!deferredElement.hasAttribute("playsinline")) {
            deferredElement.setAttribute("playsinline", "");
            deferredElement.setAttribute("webkit-playsinline", "");
          }
          var self = this;
          var hidePoster = function () {
            var poster = self.querySelector('[id^="Deferred-Poster-"]');
            var posterImages = self.querySelectorAll(".blur-up-image, img");
            if (poster) poster.style.display = "none";
            posterImages.forEach(function (img) {
              if (img.closest("deferred-media")) {
                img.style.opacity = "0";
                img.style.transition = "opacity 0.3s ease";
              }
            });
          };
          var playVideo = function () {
            hidePoster();
            var playPromise = deferredElement.play();
            if (playPromise !== undefined) {
              playPromise
                .then(function () {
                  hidePoster();
                })
                .catch(function () {
                  setTimeout(function () {
                    deferredElement
                      .play()
                      .then(function () {
                        hidePoster();
                      })
                      .catch(function () {});
                  }, 100);
                });
            }
          };
          if (deferredElement.readyState >= 2) {
            playVideo();
          } else {
            deferredElement.addEventListener("loadeddata", playVideo, {
              once: true,
            });
            deferredElement.addEventListener("canplay", playVideo, {
              once: true,
            });
            deferredElement.addEventListener("loadedmetadata", playVideo, {
              once: true,
            });
          }
          setTimeout(playVideo, 50);
        }
      }
    }
  }

  if (!customElements.get("deferred-media"))
    customElements.define("deferred-media", DeferredMedia);

  // Attach pause-on-slide-change to a single swiper container element
  function attachPauseOnSlideChange(el, swiperInstance) {
    var swiper = swiperInstance || el.swiper;
    if (swiper && !el._pauseAllMediaAttached) {
      el._pauseAllMediaAttached = true;
      swiper.on("slideChangeTransitionEnd", function () {
        if (typeof window.pauseAllMedia === "function") window.pauseAllMedia();
      });
    }
  }

  // Hook into fuzion-swiper-slider registration — called by swiper-slider-component.js
  // registerWithTheme() immediately after each swiper initialises. This is the most
  // reliable way to catch featured-product gallery swipers regardless of timing.
  var _prevRegisterThemeSwiper = window.registerThemeSwiper;
  window.registerThemeSwiper = function (component, swiperInstance) {
    if (typeof _prevRegisterThemeSwiper === "function")
      _prevRegisterThemeSwiper(component, swiperInstance);
    if (
      component &&
      swiperInstance &&
      component.closest(".fusion-featured-wrapper")
    ) {
      attachPauseOnSlideChange(component, swiperInstance);
    }
  };

  // When any product/quickview gallery swiper changes slide, pause all media
  function attachPauseAllMediaToProductGallerySwipers() {
    // PDP / quickview: fuzion-media-viewer containers
    var viewers = document.querySelectorAll("fuzion-media-viewer");
    viewers.forEach(function (viewer) {
      viewer
        .querySelectorAll(
          ".pdp_slider, .mobile_pdp_slider, .swiper-container, .swiper",
        )
        .forEach(function (el) {
          attachPauseOnSlideChange(el);
        });
    });
    // Featured-product section — fallback poll in case registerThemeSwiper missed any
    document
      .querySelectorAll(
        ".fusion-featured-wrapper .swiper-container, .fusion-featured-wrapper .swiper",
      )
      .forEach(function (el) {
        attachPauseOnSlideChange(el);
      });
  }

  // Expose so quickview open can re-run after its swiper initialises
  window.attachPauseAllMediaToGallerySwipers =
    attachPauseAllMediaToProductGallerySwipers;

  function runAfterProductGalleryReady() {
    attachPauseAllMediaToProductGallerySwipers();
    setTimeout(attachPauseAllMediaToProductGallerySwipers, 500);
    setTimeout(attachPauseAllMediaToProductGallerySwipers, 1500);
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", runAfterProductGalleryReady);
  } else {
    runAfterProductGalleryReady();
  }
  document.addEventListener(
    "shopify:section:load",
    runAfterProductGalleryReady,
  );
})();

/* Lazy image loading (including .blur-up-image) is handled by lazy-images.js */

function initCollectionTabGridFilter() {
  document
    .querySelectorAll(".fusion-filter-slider.section_type_grid")
    .forEach(function (section) {
      var tabsUL = section.querySelector("#filterOptions");
      var holder = section.querySelector("#ourHolder");
      if (!tabsUL || !holder) return;
      if (tabsUL.dataset.filterBound === "true") return;
      tabsUL.dataset.filterBound = "true";

      var items = [].slice.call(holder.querySelectorAll(".item"));
      var selectorBar = section.querySelector(".selector");

      var _selectorRaf = null;
      function updateSelector() {
        if (_selectorRaf) return;
        _selectorRaf = requestAnimationFrame(function () {
          _selectorRaf = null;
          var active = tabsUL.querySelector(".active > a");
          if (!active || !selectorBar) return;
          // Batch reads before writes to avoid forced reflow
          var left = active.offsetLeft - 1;
          var width = active.offsetWidth;
          selectorBar.style.left = left + "px";
          selectorBar.style.width = width + "px";
        });
      }
      updateSelector();
      window.addEventListener("resize", updateSelector);

      function clickHandler(e) {
        var link = e.target.closest("a");
        if (!link) return;
        e.preventDefault();
        tabsUL.querySelectorAll("li").forEach(function (li) {
          li.classList.remove("active");
        });
        link.parentElement.classList.add("active");
        updateSelector();
        var filter = link.getAttribute("data-filter");
        items.forEach(function (item) {
          var match = filter === "all" || item.dataset.filter === filter;
          item.classList.toggle("hide-anim", !match);
          item.classList.toggle("show-anim", match);
          item.style.display = match ? "" : "none";
        });
      }
      tabsUL.addEventListener("click", clickHandler);
    });
}

document.addEventListener("shopify:section:load", initCollectionTabGridFilter);
document.addEventListener("DOMContentLoaded", initCollectionTabGridFilter);
